import clsx from "clsx";
import moment from "moment";
import { FaRegEdit } from "react-icons/fa";
import { RiGlobalLine } from "react-icons/ri";
import { ImAttachment } from "react-icons/im";
import { HiOutlineDownload } from "react-icons/hi";
import { MdEmail, MdOutlineMailOutline } from "react-icons/md";
import type { RcFile } from "antd/es/upload/interface";
import { UploadRequestOption } from "rc-upload/lib/interface";
import { BiBell, BiCheck, BiChevronDown, BiLock, BiPlusCircle } from "react-icons/bi";
import { IoMdAddCircleOutline, IoMdOptions } from "react-icons/io";
import { GrAddCircle, GrDocumentUpload, GrUpdate } from "react-icons/gr";
import { FiAlertTriangle, FiExternalLink, FiRefreshCw } from "react-icons/fi";
import React, {
  Fragment,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import {
  BsTrash,
  BsWhatsapp,
  BsThreeDotsVertical,
  BsShieldCheck,
  BsEye,
  BsCheck2Circle,
} from "react-icons/bs";
import {
  PieChart,
  Pie,
  Cell,
  Legend,
  ResponsiveContainer,
  Tooltip as RechartsTooltip,
} from "recharts";
import {
  AiFillInfoCircle,
  AiOutlineSearch,
  AiOutlineCalendar,
  AiOutlineSafety,
  AiOutlineUpload,
  AiOutlineClose,
} from "react-icons/ai";
import {
  LoadingOutlined,
  MailOutlined,
  InfoCircleOutlined,
  WhatsAppOutlined,
  SyncOutlined,
} from "@ant-design/icons";
import {
  Typography,
  Input,
  Row,
  Col,
  Table,
  Modal,
  message,
  TablePaginationConfig,
  Card,
  Tooltip,
  Dropdown,
  Select,
  Collapse,
  Tag,
  Tabs,
  Checkbox,
  Divider,
  Badge,
} from "antd";
import api from "../../services/api";
import { dayFilters, yearFilters } from "../Darfs";
import Button from "../../components/Button";
import Loading from "../../components/Loading";
import apiBolsa from "../../services/bolsa-api";
import { useAuth } from "../../contexts/AuthContext";
import { usePlanVerification } from "../../hooks/usePlanVerification";
import { ChartBar } from "../../components/ChartBar";
import { FormModal } from "../../components/FormModal";
import { Avisos } from "../../components/Avisos/Avisos";
import UploadVelotax from "../../components/UploadVelotax";
import { Previdencia } from "../../components/Previdencia";
import { ClientFormItemRows } from "../../constants/clients";
import { UserPlanModal } from "../../components/UserPlanModal";
import { ProventosModal } from "../../components/ProventosModal";
import { OperationModal } from "../../components/OperationModal";
import { SendDarfModal } from "../../components/Darf/SendDarfModal";
import { IntegrationModal } from "../../components/IntegrationModal";
import UploadNotas from "../../components/NotasCorretagem/UploadNotas";
import { ExpandIcon, PosicaoCard } from "../../components/PosicaoCard";
import { ReactComponent as SeloIcon } from "../../assets/icons/selo.svg";
import { ReactComponent as EmptyIcon } from "../../assets/icons/empty.svg";
import { ReactComponent as FiltroIcon } from "../../assets/icons/filtro.svg";
import DeleteConfirmationModal from "../../components/DeleteConfirmationModal";
import { getNomeCorretora, serializePatrimonio } from "../../utils/patrimonio";
import { NotificationDrawer } from "../../components/Notification/Notification";
import { ReportTypeDrawer } from "../../components/ReportType/ReportType";
import { CalcStatus, IClient, useClients } from "../../contexts/ClientsContext";
import { ReactComponent as SelectionIcon } from "../../assets/icons/selection.svg";
import { useNotasCorretagem } from "../../components/NotasCorretagem/useNotasCorretagem";
import {
  downloadPDF,
  formatCurrency,
  formatCurrencySmart,
  maskCpf,
  isMobile,
  numberToCurrency,
  numberToPercentage,
  numberToPhone,
  monthsExtended,
  vendasTotais,
  vendasTotaisExt,
  mesesPassados,
  download,
  arrow,
  negativeToPositive,
  thirdBusinessDayAndMonth,
  isAntesTerceiroDiaUtil,
  formatDateHour,
  isAlreadyFormatted,
} from "../../utils";
import {
  ClientContainer,
  ClientPlanContent,
  Container,
  ContainerProventos,
  Content,
  EmptyContainer,
  RetornoLabel,
  SideContent,
  IsentCardStyled,
  DarfFilterButton,
  FilterDarfs,
  DarfCard,
  ConatinerDarfs,
  BlurBox,
  PlanContainer,
  SearchInputClients,
  CardsContainer,
  TitleCorretora,
  ValueCorretora,
  PercentageCorretora,
  CardCorretora,
} from "./styles";
import _ from "lodash";
import { Planos } from "../../components/Planos";
import { yearConfigPL4173 } from "../../constants/others/exterior";

const freeTaxLimit = 10;

const Months: any = {
  0: "Janeiro",
  1: "Fevereiro",
  2: "Março",
  3: "Abril",
  4: "Maio",
  5: "Junho",
  6: "Julho",
  7: "Agosto",
  8: "Setembro",
  9: "Outubro",
  10: "Novembro",
  11: "Dezembro",
};

const b3Encoded =
  "https%3A%2F%2Fb3investidor.b2clogin.com%2Fb3Investidor.onmicrosoft.com%2Foauth2%2Fv2.0%2Fauthorize%3Fp%3DB2C_1A_FINTECH%26client_id%3D069ecfdf-7471-48eb-be82-d50799c99e5c%26nonce%3DdefaultNonce%26redirect_uri%3Dhttps%253A%252F%252Fwww.investidor.b3.com.br%26scope%3Dopenid%26response_type%3Dcode%26prompt%3Dlogin";

const mailTypes = [
  {
    value: "b3-integration",
    whatsappMessage:
      "Olá {fullname}, realize a integração da sua conta na B3 com o Velotax para auxiliar na conferência do seu imposto de renda mensal (DARF). Para realizar a integração clique no link: ",
    link: b3Encoded,
    label: () => (
      <>
        Solicitar integração <b>B3</b>
      </>
    ),
    icon: () => (
      <ImAttachment
        style={{
          marginBottom: "20px",
          width: "30px",
          height: "30px",
          color: "var(--yellow)",
        }}
      />
    ),
  },
  {
    value: "exterior-integration",
    whatsappMessage:
      "Olá {fullname}, realize a integração da sua conta no exterior com o Velotax para auxiliar na conferência do seu imposto de renda mensal (DARF). Veja como fazer no link: ",
    link: "https://youtu.be/atYsUXLHOPE?feature=shared",
    label: () => (
      <>
        Solicitar integração <b>Exterior</b>
      </>
    ),
    icon: () => (
      <RiGlobalLine
        style={{
          marginBottom: "20px",
          width: "30px",
          height: "30px",
          color: "var(--yellow)",
        }}
      />
    ),
  },
  {
    value: "pending-calc",
    whatsappMessage:
      "Olá {fullname}, realize a emissão do seu DARF de junho de 2023. Para emiti-lo, clique no link: ",
    link: "https://xp.velotax.com.br/p/login",
    label: () => (
      <>
        Lembrar sobre <b>cálculo pendente</b>
      </>
    ),
    icon: () => (
      <AiOutlineCalendar
        style={{
          marginBottom: "20px",
          width: "30px",
          height: "30px",
          color: "var(--yellow)",
        }}
      />
    ),
  },
  {
    value: "hiring-plan",
    whatsappMessage:
      "Olá {fullname}, realize a contratação do plano premium no Velotax para auxiliar na conferência do seu imposto de renda mensal (DARF). Para contratar o plano premium, clique no link: ",
    link: "https://xp.velotax.com.br/p/login",
    label: () => (
      <>
        Solicitar que o <b>cliente contrate o plano</b>
      </>
    ),
    icon: () => (
      <AiOutlineSafety
        style={{
          marginBottom: "20px",
          width: "30px",
          height: "30px",
          color: "var(--yellow)",
        }}
      />
    ),
  },
];

var debounce: NodeJS.Timeout;

const Responsaveis: React.FC<{ item: IClient }> = ({ item }) => (
  <div className="resp" style={{ marginTop: '8px', fontSize: '14px', color: '#666' }}>
    {!item.resp || item.resp?.length === 0 ? (
      <span style={{ fontStyle: 'italic' }}>Escritório</span>
    ) : (
      <>
        <span style={{ fontWeight: '500' }}>Assessores: </span>
        {item.resp?.map((resp: any, index: number, array: any[]) => (
          <span key={index}>
            {resp.name}
            {index === array.length - 1 ? "" : ", "}
          </span>
        ))}
      </>
    )}
  </div>
);

const PatrimonioSemPercentual = () => (
  <Tooltip title="Aguarde a atualização do patrimônio deste cliente">
    <LoadingOutlined />
  </Tooltip>
);

const tooltip: any = () => (
  <p
    style={{
      margin: "15px",
      fontSize: "13px",
      display: "flex",
      textAlign: "center",
    }}
  >
    O usuário já possui uma conta cadastrada na plataforma. Enviamos um e-mail
    solicitando a sua permissão de acesso à conta e estamos aguardando a
    confirmação do usuário.
  </p>
);

const handleVencimento = (data: IClient) => {
  // clientPlanActive: planActive da collection clients
  // planCancelPending: cancelPending da collection payment
  if ((!data.planActive || data.planCancelPending) && data.planDueDate) {
    const currentMonth = new Date().getMonth();
    const currentYear = new Date().getFullYear();
    const currentDay = new Date().getDate();
    const currentHour = new Date().getHours() + 3;
    const currentMinute = new Date().getMinutes();
    const valido =
      data.planDueDate >=
      Date.UTC(
        currentYear,
        currentMonth,
        currentDay,
        currentHour,
        currentMinute
      );
    if (valido) {
      return moment(new Date(data.planDueDate)).format("DD/MM/YYYY");
    }
    return "";
  } else {
    return "";
  }
};



const chartColors = [
  { background: "#006100", label: "white" },
  { background: "#00BC75", label: "white" },
  { background: "#C7D200", label: "white" },
  { background: "#FBC105", label: "white" },
  { background: "#FF8000", label: "white" },
  { background: "#E50045", label: "white" },
  { background: "#FF2B00", label: "white" },
  { background: "#79002A", label: "white" },
];

// Função para verificar se deve bloquear envio de DARF baseado no mês anterior
const shouldBlockDarfSend = (item: any) => {
  const today = new Date();
  const currentMonth = today.getMonth() + 1;
  const currentYear = today.getFullYear();
  
  // Calcula o mês anterior
  let previousMonth = currentMonth - 1;
  let previousYear = currentYear;
  
  if (previousMonth === 0) {
    previousMonth = 12;
    previousYear = currentYear - 1;
  }
  
  // Verifica se o DARF é do mês anterior
  const isPreviousMonthDarf = item.month === previousMonth && item.year === previousYear;
  
  // Só bloqueia se for DARF do mês anterior e estivermos antes do dia 7
  return isPreviousMonthDarf && isAntesTerceiroDiaUtil();
};

// Hook para detectar o tamanho da tela
const useWindowSize = () => {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowSize;
};

export const Clients: React.FC = () => {
  const { width: windowWidth } = useWindowSize();
  const { user } = useAuth();

  const {
    files,
    history,
    setFiles,
    sendNotas,
    getHistory,
    loadingSend,
    uploadProps,
    downloadNota,
    showNotasCorretagemModal,
    setShowNotasCorretagemModal,
  } = useNotasCorretagem();
  const {
    clients,
    newClient,
    loadingGet,
    getClients,
    getProventos,
    getPatrimonios,
    getNotifications,
    proventos,
    // patrimonios,
    notificacoes,
    loadingLogin,
    removeClient,
    createClient,
    setNewClient,
    totalClients,
    totalPatrimonio,
    totalPatrimonioReverse,
    updateClient,
    loginInClient,
          setLoadingGet,
      professionals,
      restoreClient,
    selectedClient,
    getProfessionals,
    setSelectedClient,
    handleDownloadSheet,
    createClientDeleted,
    typeProventos,
    setTypeProventos,
    patrimoniosLoading,
    setCreateClientDeleted,
    setYearProventos,
    yearProventos,
    proventosLoading,
    proventosFileUrl,
    patrimoniosFileUrl,
    getClientsUpdating
  } = useClients();

  const [, setLoadingMail] = useState("");
  const [, setLoadingToken] = useState(false);
  const [errors, setErrors] = useState<any>([]);
  const [open, setOpen] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [, setDetailedActiveKeys] = useState<string[]>([]);
  const [activeKeys, setActiveKeys] = useState<string[]>([]);
  const [monthProventos, setMonthProventos] = useState<any>({});
  const [loadingProventos, setLoadingProventos] = useState(false);
  const [detailedPositions, setDetailedPositions] = useState<any[]>([]);
  const [hideValues] = useState(false);
  const [, setHelpModal] = useState<any>();
  const [keys, setKeys] = useState<string[]>([]);
  const [filters, setFilters] = useState<any>({});
  const [searchText, setSearchText] = useState("");
  const [itemRemove, setItemRemove] = useState<any>({});
  const [loadingFile, setLoadingFile] = useState(false);
  const [loading, setLoading] = useState(false);
  const [optionsModal, setOptionsModal] = useState(false);
  const [showDarfTooltip, setShowDarfTooltip] = useState(false);
  const [, setVisibleChart] = useState(false);
  const [visibleTabs, setVisibleTabs] = useState(true);
  const [firstSelected, setFirsSelected] = useState(false);
  const [chartType, setChartType] = useState("patrimonio");
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [userSelected, setUserSelected] = useState<any>({});
  const [sendRequest, setSendRequest] = React.useState(true);
  const [paymentType, setPaymentType] = useState<any>("anual");
  const [appliedFilters, setAppliedFilters] = useState<any>({});
  const [csvModalVisible, setCsvModalVisible] = useState(false);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [showCorretoraFilterModal, setShowCorretoraFilterModal] =
    useState(false);
  const [filterCorretoraAtivo, setFilterCorretoraAtivo] = useState<string[]>(
    []
  );
  const [, setConfirmPlanModal] = useState(false);
  const [errorModalVisible, setErrorModalVisible] = useState(false);
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [createModalVisible, setCreateModalVisible] = useState(false);
  const [removeModalVisible, setRemoveModalVisible] = useState(false);
  const [assessoresSelected, setAssessoresSelected] = useState<any>([]);
  const [updateAllPatrimonio, setUpdateAllPatrimonio] = useState(false);
  const [assessoresListModal, setAssessoresListModal] = useState(false);
  const [clientsSelected, setClientsSelected] = useState<IClient[]>([]);
  const [vendasBolsa, setVendasBolsa] = useState<any>(0);
  const [vendasExterior, setVendasExterior] = useState<any>(0);
  const [vendasRestantesBolsa, setVendasRestantesBolsa] = useState<any>(0);
  const [vendasRestantesExterior, setVendasRestantesExterior] =
    useState<any>(0);
  const [sendMailModalVisible, setSendMailModalVisible] = useState(false);
  const [checkboxCorretoras, setCheckboxCorretoras] = useState<string[]>([]);
  const [selectedCorretoras, setSelectedCorretoras] = useState<string[]>([]);
  const [patrimonioModalVisible, setPatrimonioModalVisible] = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(0);
  const [showMobileActionSelectedClients, setShowMobileActionSelectedClients] =
    useState(false);
  const [selectedNotificationType, setSelectedNotificationType] = useState<
    any | undefined
  >(undefined);
  const [integrationModal, setIntegrationModal] = useState<
    "B3" | "XP International" | null
  >(null);
  const [integrationClient, setIntegrationClient] = useState<IClient | null>(
    null
  );
  const [currentTab, setCurrentTab] = useState<string>("investimentos");
  const [darfs, setDarfs] = useState<Array<any>>([]);
  const [typeDarf, setTypeDarf] = useState('');
  const [yearDarf, setYearDarf] = useState(new Date().getFullYear());
  const [prevDarfTabClient, setPrevDarfTabClient] = useState<
    string | undefined
  >();
  const [darfLoading, setDarfLoading] = useState(false);
  const [modalOperationsOpen, setModalOperationsOpen] = useState(false);
  const [sendToResp, setSendToResp] = useState(false);
  const [showSendDarfModal, setShowSendDarfModal] = useState(false);
  const [darfSelected, setDarfSelected] = useState<IClient[]>([]);
  const [whatsappRedirectURL, setWhatsappRedirectURL] = useState<
    string | undefined
  >(undefined);
  const [notificationDrawerOpen, setNotificationDrawerOpen] = useState(false);
  const [reportDrawerWallet, setReportDrawerWallet] = useState(false);
  const [reportDrawerProventos, setReportDrawerProventos] = useState(false);
  const [posicoesFilter, setPosicoesFilter] = useState([]);
  const [pagination] = useState<TablePaginationConfig>({
    current: currentPage,
    pageSize: 10,
    defaultPageSize: 10,
    showSizeChanger: false, // mudar para true quando o back estiver aceitando
    pageSizeOptions: ["5", "10", "20", "50", "100"],
  });
  const [detailedLoadingIndex, setDetailedLoadingIndex] = useState<
    number | undefined
  >();
  const [showUpgradePlan, setShowUpgradePlan] = useState(false);
  const [isLoadingClientData, setIsLoadingClientData] = useState(false);

  const clientsToUpgrade = clientsSelected.filter(
    (client) => client.planName && !client.isConcierge && !client.planName.includes('CONCIERGE')
  )

  const getData = async () => {
    try {
      // const { data } = await api.get("/dashboard");
      await api.get("/dashboard");
    } catch (err) {
      message.error("Ocorreu um erro ao buscar as informações do dashboard");
    }
  };

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    setPosicoesFilter(selectedClient?.wallet?.filters)
  }, [selectedClient]);

  // COMENTADO: useEffect que verifica integração B3 a cada 3 segundos
  // Pode estar atrapalhando outras consultas com requisições excessivas
  
  // useEffect(() => {
  //   let interval: NodeJS.Timeout | null = null;
  //   const clientsUpdatingB3Integration = clients.filter(
  //     (c) => c.updatingB3Integration
  //   );
  //   if (clientsUpdatingB3Integration.length) {
  //     interval = setInterval(() => {
  //       getClientsUpdating();
  //     }, 3000);
  //   } else {
  //     if (interval) {
  //       clearInterval(interval);
  //     }
  //   }
  //   return () => clearInterval(interval as unknown as NodeJS.Timeout);
  // }, [clients, getClientsUpdating]);
  


  useEffect(() => {
    if (typeDarf === '' && selectedClient) {
      if (selectedClient?.statusBolsa === 'Integração ativa') {
        setTypeDarf('Bolsa')
      } else if (selectedClient?.statusExterior === 'Integração ativa') {
        setTypeDarf('Exterior')
      } else {
        setTypeDarf('Bolsa')
      }
    }
  }, [selectedClient, typeDarf]);




  const hosts = ["-dev", "local"];
  const env = hosts.some((host) => window.location.host.includes(host))
    ? "_dev"
    : "";
  const isManagerOrOffice = user.user?.isManager || user?.user?.office;

  // Definição de temInvestimentos movida para antes do useEffect
  // Mostra a aba de investimentos se o cliente tem wallet, mesmo com patrimônio zero
  const temInvestimentos = !!selectedClient?.wallet;

  const { patrimonio, classesAtivos, posicoes, corretoras } = useMemo(
    () => {
      const resultado = serializePatrimonio(selectedClient, selectedCorretoras);
      return resultado;
    },
    [selectedClient, selectedCorretoras]
  );


  useEffect(() => {
    // Lógica melhorada para navegação entre tabs
    if (!temInvestimentos) {
      // Se não tem investimentos, vai para DARFs
      setCurrentTab("darfs");
    } else if (temInvestimentos && !currentTab) {
      // Se tem investimentos e não há tab selecionada, vai para investimentos
      setCurrentTab("investimentos");
    } else if (temInvestimentos && currentTab === "darfs") {
      // Se tem investimentos mas está na aba DARFs, mantém a escolha do usuário
      // Não força redirecionamento automático
    }
  }, [selectedClient, temInvestimentos]);

  // Resetar o ano para o ano atual sempre que a aba darfs for selecionada
  useEffect(() => {
    if (currentTab === "darfs") {
      // Remove a lógica que forçava o reset para o ano atual
      // Agora o usuário pode selecionar qualquer ano e ele será mantido
    }
  }, [currentTab]);

  const checkAll = corretoras.length === checkboxCorretoras.length;
  const indeterminate =
    checkboxCorretoras.length > 0 &&
    checkboxCorretoras.length < corretoras.length;

  const handleDisabled = (item: any) => {
    const codes = (item.code || []).filter(
      (el: any) =>
        el?.escritorioId?.toString() === user?.user?.officeId?.toString() ||
        el?.assessorId?.toString() === user?.user?.assessorId?.toString()
    );

    return !codes.some((el: any) => !!el?.isAuthorized);
  };

  const updateFilter = async () => {
    setLoadingGet(true)
    api.patch('/clients/wallet/filter', {
      username: selectedClient?.username,
      filters: posicoesFilter || []
    })
      .then(() => {
        getClients({
          ...filters,
          searchText: searchText ? searchText : '',
          page: currentPage,
          pageSize: pagination.pageSize,
          selectClient: selectedClient?.username
        })
      })
      .catch((err) => {
        console.log(err)
      })
  }
  const carteiraCategorizadaSemFiltros = useMemo(
    () =>
      selectedClient?.wallet?.posicoes?.reduce(
        (acc: any, cur: any) => ({
          ...acc,
          [cur.categoria]: [...(acc[cur.categoria] || []), cur],
        }),
        {} as { [key: string]: any }
      ) || {},
    [selectedClient?.wallet]
  );

  const carteiraCategorizada = useMemo(
    () =>
      selectedClient?.wallet?.posicoes
        ?.filter((p: any) => (selectedClient?.wallet?.filters?.length ? selectedClient?.wallet?.filters : [p.codigo]).includes(p.codigo))
        ?.reduce(
          (acc: any, cur: any) => ({
            ...acc,
            [cur.categoria]: [...(acc[cur.categoria] || []), cur],
          }),
          {} as { [key: string]: any }
        ) || {},
    [selectedClient?.wallet?.posicoes]
  );

  const beforeUpload = (file: RcFile) => {
    setSendRequest(true);
    if (
      ![
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-excel",
        "text/x-csv",
        "text/plain",
        "text/tab-separated-values",
        "text/x-comma-separated-values",
        "text/comma-separated-values",
        "application/x-csv",
        "application/csv",
      ].includes(file.type)
    ) {
      message.error("Envie um arquivo do tipo CSV");
      setSendRequest(false);
    }
  };

  const handleRemoveModal = (item?: any) => {
    setItemRemove(item);
    setRemoveModalVisible(!removeModalVisible);
  };

  const handlePatrimonioModal = (item?: any) => {
    setPatrimonioModalVisible(!patrimonioModalVisible);
    setUpdateAllPatrimonio(false);
  };

  const renderLegend = (value: string, entry: any) => {
    return <span style={{ color: "black", fontWeight: 500 }}>{value}</span>;
  };

  const renderCustomizedLabel = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    percent,
    payload,
  }: any) => {
    const RADIAN = Math.PI / 180;
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    // Determina a cor do texto baseada na cor de fundo
    let fill = "white"; // cor padrão
    if (payload.fill && payload.fill.includes("linear-gradient")) {
      // Para gradientes, usa a cor mais clara
      fill = "white";
    } else {
      // Para cores sólidas, verifica o contraste
      const colorIndex = chartColors.findIndex(
        (colors) => colors.background === payload.fill
      );
      if (colorIndex !== -1) {
        fill = chartColors[colorIndex].label;
      }
    }

    return (
      <text
        x={x}
        y={y}
        fill={fill}
        textAnchor="middle"
        dominantBaseline="central"
        fontSize={11}
        fontWeight="600"
        style={{
          margin: "10px",
          textShadow: "1px 1px 2px rgba(0,0,0,0.5)",
          filter: "drop-shadow(0 1px 2px rgba(0,0,0,0.3))"
        }}
      >
        {percent * 100 > 4 && `${(percent * 100).toFixed(0)}%`}
      </text>
    );
  };

  const getProviderColor = (provider: string, index: number) => {
    // Sistema de rotação de cores para efeito 3D
    let colorIndex = index;
    while (colorIndex >= chartColors.length) {
      colorIndex = colorIndex - chartColors.length;
    }
    return chartColors[colorIndex].background;
  };


  const customRequest = ({ file }: UploadRequestOption) => {
    const formData = new FormData();
    if (!sendRequest) return;
    formData.append("file", file);
    setLoadingFile(true);
    api
      .post("/clients/batch", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then(({ data }) => {
        setLoadingFile(false);
        setCsvModalVisible(!csvModalVisible);
        if (data.errors.length === 0) {
          message.success("Integração iniciada com sucesso");
        } else {
          message.error(
            "Erro durante inserção. Favor conferir no modal apresentado."
          );
          setErrors(data.errors);
          setErrorModalVisible(true);
        }
        getClients({ page: currentPage });
      })
      .catch((error) => {
        setLoadingFile(false);
        message.error(error.response.data.message);
      });
  };

  const setDeleteModalVisiblity = () => {
    setDeleteModalVisible(!deleteModalVisible);
  };

  const handleSearch = (value: string) => {
    setSearchText(value);
    if (debounce) clearTimeout(debounce);
    debounce = setTimeout(() => {
      getClients({
        ...filters,
        searchText: value,
        page: pagination.current,
        pageSize: pagination.pageSize,
      });
    }, 1000);
  };

  const handlePlan: any = async (client?: IClient) => {
    if (client) {
      setLoadingToken(true);
      setSelectedClient(client);
      setLoadingToken(false);
    } else {
      setKeys([]);
      setClientsSelected([]);
      setConfirmPlanModal(false);
      setShowMobileActionSelectedClients(false);
    }
  };

  const createPlanFromSelectedUsers = async () => {
    try {
      const filteredClients = clientsSelected.filter(
        (client) => !client.planActive
      );
      const usernames = filteredClients.map((client) => client.username);
      const { data } = await api.post("/plans", {
        usernames,
        type: paymentType.toLowerCase(),
      });
      getClients({
        ...filters,
        searchText: searchText.length > 0 ? searchText : null,
        page: currentPage,
      });
      message.success(
        `${data.count} Clientes adicionados no Plano premium com sucesso`
      );
    } catch (err) {
      message.success("Ocorreu um erro ao adicionar os clientes no plano");
    } finally {
      setShowPaymentModal(false);
      setConfirmPlanModal(false);
      setKeys([]);
      setClientsSelected([]);
    }
  };



  const sendMail = async (type: string, clients?: IClient[]) => {
    try {
      setSendMailModalVisible(false);
      setSelectedNotificationType(undefined);
      setLoadingGet(true);
      setLoadingMail(type);
      await api.post("/clients/send-mail", {
        type,
        clients: clients ?? clientsSelected,
      });
      setSendMailModalVisible(false);
      setSelectedNotificationType(undefined);
      setClientsSelected([]);
      setKeys([]);
    } catch {
      message.error("Algo inesperado aconteceu. Tente novamente");
    } finally {
      message.success("Suas solicitações foram enviadas");
      setLoadingGet(false);
      setLoadingMail("");
    }
  };

  const setOptionsModalVisibility = () => {
    setOptionsModal(!optionsModal);
    setNewClient(null);
  };

  const setCreateModalVisibility = () => {
    setCreateModalVisible(!createModalVisible);
    setOptionsModal(!optionsModal);
    setNewClient(null);
  };

  const setCsvModalVisibility = () => {
    setCsvModalVisible(!csvModalVisible);
    setOptionsModal(!optionsModal);
    setNewClient(null);
  };

  const handleRemove = () => {
    setLoadingGet(true);
    setRemoveModalVisible(!removeModalVisible);
    api.post("/clients/remove", { ...itemRemove }).then(() => {
      getClients({ page: currentPage });
    });
  };

  const handleEdit = (item: any) => {
    setUserSelected(clients.find((obj: any) => obj.userId === item.userId));
    setNewClient(clients.find((obj: any) => obj.userId === item.userId));
    setCreateModalVisible(!createModalVisible);
  };

  const handleUpdatePatrimonio = async (item: any) => {
    try {
      setLoadingGet(true);
      const { data } = await api.get(
        "/clients/updatePatrimonio/" + item.username
      );
      if (data?.message) message.info(data.message, 5);
      else setSelectedClient((item: any) => ({ ...item, wallet: data }));
    } catch (error) {
      setLoadingGet(false);
      message.error(
        "Não foi possível atualizar o patrimônio. Tente novamente mais tarde"
      );
    } finally {
      setLoadingGet(false);
      setPatrimonioModalVisible(false);
      setUpdateAllPatrimonio(false);
    }
  };
  
  useEffect(() => {
    setAssessoresSelected(
      //@ts-ignore
      clients
        ?.filter((item: any) => item.username === selectedClient?.username)[0]
        ?.resp?.map((resposavel: any) => resposavel._id)
    );
    // eslint-disable-next-line
  }, [assessoresListModal, createModalVisible, clients]);

  useEffect(() => {
    if (user?.user?.office || user?.user?.admin)
      getProfessionals(undefined, undefined, true);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    getClients();
  }, [getClients]);

  // useRef para evitar loops infinitos
  const lastProcessedUsername = useRef<string | null>(null);

  useEffect(() => {
    
    if (selectedClient?.username && selectedClient.username !== lastProcessedUsername.current) {
      lastProcessedUsername.current = selectedClient.username;
      setIsLoadingClientData(true);
      
         if(!hasPlan) {
          setIsLoadingClientData(false);
          return;
         }
      
      // Só carrega dados se o cliente não foi atualizado recentemente
      // (evita conflito com handleUpdatePatrimonio que já atualiza os dados)
      if (!selectedClient.wallet?.posicoes || selectedClient.wallet.posicoes.length === 0) {
        // Carregar dados em paralelo e aguardar conclusão
        Promise.all([
          getPatrimonios(selectedClient.username),
          getNotifications(selectedClient.username)
        ]).finally(() => {
          // Mantém o loading por um tempo mínimo para mostrar o spinner
          setTimeout(() => {
            setIsLoadingClientData(false);
          }, 500);
        });
      } else {
        // Se já tem dados, só carrega notificações
        getNotifications(selectedClient.username);
        // Mantém o loading por um tempo mínimo para mostrar o spinner
        setTimeout(() => {
          setIsLoadingClientData(false);
        }, 500);
      }
    }
    
  }, [selectedClient?.username]);

  useEffect(() => {
    getProventos(selectedClient?.username!, yearProventos);
  }, [yearProventos, selectedClient?.username]);

  useEffect(() => {
    if (selectedClient?.username) {
      api
        .post(`/clients/insentometroTransactions`, {
          username: selectedClient.username,
          month: new Date().getMonth() + 1,
        })
        .then((res) => {
          setVendasBolsa(vendasTotais(res?.data[0]));
          setVendasRestantesBolsa(20000 - vendasTotais(res?.data[0]));
          setVendasExterior(vendasTotaisExt(res?.data[1]));
          setVendasRestantesExterior(35000 - vendasTotaisExt(res?.data[1]));
        })
        .catch(() => { });
    }
  }, [selectedClient?.username]);

  useEffect(() => {
    if (!isMobile() && !firstSelected && clients?.length > 0) {
      setFirsSelected(true);
      setIsLoadingClientData(true);
      setSelectedClient(clients[0]);
      handleUpdatePatrimonio(clients[0]);
    }
  }, [clients, firstSelected, setSelectedClient]);

  // useEffect específico para atualizar patrimônio quando o primeiro cliente é selecionado
  useEffect(() => {
    if (!isMobile() && selectedClient && clients?.length > 0 && selectedClient.username === clients[0]?.username) {
      handleUpdatePatrimonio(selectedClient);
    }
  }, [selectedClient?.username, clients]);

  useEffect(() => {
    setYearProventos(new Date().getFullYear());
    if (!isMobile() && !!selectedClient?.username) {
      const index = clients.findIndex(
        (c) => c.userId === selectedClient.userId
      );
      if (index < 0) {
        setSelectedClient(clients[0]);
        handleSelectedTab(clients[0]);
        setActiveKeys([]);
        setDetailedPositions([]);
        setDetailedActiveKeys([]);
        setCheckboxCorretoras([]);
        setSelectedCorretoras([]);
        setFilterCorretoraAtivo([]);
        setVisibleTabs(false);
        setTimeout(() => {
          setVisibleTabs(true);
        }, 1000);
      }
    }
  }, [
    selectedClient?.username,
    selectedClient?.userId,
    clients,
    setSelectedClient,
    setYearProventos,
    firstSelected,
  ]);

  const handleSelectedTab = (item: IClient) => {
    if (!!item?.wallet && (item?.wallet?.posicoes?.length || 0) > 0) {
      setCurrentTab("investimentos");
    } else if (item?.code?.[0].isAuthorized) {
      setCurrentTab("darfs");
    }
  };

  const handleChangeAssessores = (value: string[]) => {
    setAssessoresSelected(value);
  };

  const onInputBlur = (inputName: string, value: string) => {
    const clientAttr: any = newClient;
    if (inputName === "plan" && value === "free") {
      return;
    }
    if (!!clientAttr) {
      if (inputName === "plan" && value !== "free") {
        clientAttr["planType"] = value;
      } else if (inputName === "phone") {
        clientAttr[inputName] = value.replace(/[_.-/-() ]/g, "");
      } else {
        clientAttr[inputName] = value;
      }
      setNewClient({ ...clientAttr });
    }
  };

  const sendPermissionEmail = async (item: any) => {
    try {
      await api.post("/clients/sendPermissionEmail", {
        username: item?.username || "",
      });
      message.success("E-mail de solicitação de acesso enviado");
    } catch (err: any) {
      message.error(
        "Não foi possível enviar o e-mail de solicitação de acesso. Tente novamente mais tarde"
      );
    }
  };

  const patrimonioFiltrado = useMemo(
    () => {
      const resultado = selectedClient?.wallet?.posicoes?.reduce(
        (acc: any, cur: any) => {
          if (filterCorretoraAtivo.includes(cur.corretora)) {
            return {
              patrimonioTotalFiltrado:
                acc.patrimonioTotalFiltrado + cur.posicao,
              lucroPrejuizoDiario:
                acc.lucroPrejuizoDiario + cur.lucroPrejuizoDiario,
              lucroPrejuizoDiarioPercentualNumerator:
                acc.lucroPrejuizoDiarioPercentualNumerator +
                (cur.categoria === "TesouroDireto"
                  ? 0
                  : cur.resumo?.lucroPrejuizoDiarioPercentualNumerator),
              lucroPrejuizoDiarioPercentualDenominator:
                acc.lucroPrejuizoDiarioPercentualDenominator +
                (cur.categoria === "TesouroDireto"
                  ? 0
                  : cur.resumo?.lucroPrejuizoDiarioPercentualDenominator),
              lucroPrejuizoTotal:
                acc.lucroPrejuizoTotal + cur.lucroPrejuizoTotal,
              lucroPrejuizoTotalPercentualNumerator:
                acc.lucroPrejuizoTotalPercentualNumerator +
                cur.resumo?.lucroPrejuizoTotalPercentualNumerator,
              lucroPrejuizoTotalPercentualDenominator:
                acc.lucroPrejuizoTotalPercentualDenominator +
                cur.resumo?.lucroPrejuizoTotalPercentualDenominator,
            };
          } else {
            return acc;
          }
        },
        {
          lucroPrejuizoDiario: 0,
          lucroPrejuizoDiarioPercentualNumerator: 0,
          lucroPrejuizoDiarioPercentualDenominator: 0,
          lucroPrejuizoTotal: 0,
          lucroPrejuizoTotalPercentualNumerator: 0,
          lucroPrejuizoTotalPercentualDenominator: 0,
          patrimonioTotalFiltrado: 0,
        }
      ) || {
        lucroPrejuizoDiario: 0,
        lucroPrejuizoDiarioPercentualNumerator: 0,
        lucroPrejuizoDiarioPercentualDenominator: 0,
        lucroPrejuizoTotal: 0,
        lucroPrejuizoTotalPercentualNumerator: 0,
        lucroPrejuizoTotalPercentualDenominator: 0,
        patrimonioTotalFiltrado: 0,
      };

      return resultado;
    },
    [selectedClient?.wallet?.posicoes, filterCorretoraAtivo]
  );

  const downloadRelatorio = async (
    type: string,
    category: string,
    item: any
  ) => {
    try {
      setLoadingGet(true);

      if (type === "pdf") {
        let fileUrl = "";
        let file = "";
        if (category === "patrimônios") {
          const ret = await api.post("/clients/downloadRelatorio", {
            username: item.username,
            userId: item.userId,
            escritorioId: item.code[0].escritorioId,
            corretoras: filterCorretoraAtivo,
          });
          getClients({
            ...filters,
            searchText: searchText.length > 0 ? searchText : null,
            page: currentPage,
          });
          if (ret) {
            fileUrl = ret?.data?.fileUrl;
            file = ret?.data?.file;
          }
        } else if (category === "proventos") {
          const escritorioId =
            selectedClient && selectedClient?.code
              ? selectedClient?.code[0].escritorioId
              : null;
          const newProventos = proventos.map((el: any) => {
            return {
              code: el.code || "",
              date: moment(el?.date).format("DD/MM/YYYY"),
              corporateActionTypeDescription: _.capitalize(
                el?.corporateActionTypeDescription
              ),
              corretora: el?.corretora,
              quantity: el?.quantity || "-",
              unitPrice: el?.unitPrice,
              grossAmount: el?.grossAmount,
            };
          });
          const ret = await api.post("/clients/downloadRelatorioProventos", {
            proventos: newProventos,
            escritorioId: escritorioId,
            username: selectedClient?.username
          });
          if (ret) {
            fileUrl = ret?.data?.fileUrl;
            file = ret?.data?.file;
          }
        }
        if (fileUrl) {
          download(fileUrl);
        } else if (file) {
          downloadPDF(
            file,
            `${category === "patrimônios" ? "Meus Investimentos" : "Proventos"}`
          );
        }
      } else if (type === "xlsx") {
        if (category === "patrimônios") {
          if (filterCorretoraAtivo?.length > 0 || posicoesFilter?.length > 0) {
            const res = await api.post(
              "/clients/downloadRelatorioPatrimonioXlsx",
              {
                username: item.username,
                corretoras: filterCorretoraAtivo,
                posicoes: posicoesFilter
              }
            );
            download(res?.data?.fileUrl);
          } else {
            download(patrimoniosFileUrl);
          }
        } else if (category === "proventos") {
          download(proventosFileUrl);
        }
      }
      setLoadingGet(false);
    } catch (err: any) {
      console.log(err, "err")
      setLoadingGet(false);
      console.error(err);
      message.error(
        `Não foi possível baixar o relatório de ${category}. Tente novamente mais tarde`
      );
    }
  };

  const handleOpenFilterModal = () => {
    setShowFilterModal(true);
  };

  const getPlan = (item: any) => {
    return (
      <>
        {'PLANO '}
        {item?.planName?.includes('_BASIC') ? 'BASIC ' : ''}
        {item?.planName?.includes('_CONCIERGE') ? 'CONCIERGE ' : ''}
        {item?.planName?.includes('_PRO') ? 'PREMIUM ' : ''}
        {item?.planName?.includes('ASSESSOR') ? 'ASSESSOR ' : ''}
        {(item.planType !== 'exterior')
          ? ((item?.planName?.includes('_MONTH') || item?.planType?.includes('mensal')) ? 'MENSAL' : 'ANUAL')
          : item.planName?.includes('ASSESSOR') ? ''
            : 'GRATUITO EXTERIOR'}
        {item.planType === "exterior"
          ? ""
          : item.hasPlanXp
            ? " (CLIENTE)"
            : " (ESCRITÓRIO)"}
      </>
    )
  }

  const ClientPlan: React.FC<{ item: IClient & { wallet: any } }> = ({
    item,
  }) => {
    return (
      <ClientPlanContent>
        {item.planActive || item.planDueDate > new Date().getTime() || item.planType === "exterior" || item.planName === 'ASSESSOR' ? (
          <Typography.Text className="client-plan">
            {getPlan(item)}
            {handleDisabled(item) ? (
              <>&nbsp;&nbsp;|&nbsp;&nbsp;Solicite permissão ao usuário</>
            ) : item.wallet ? (
              <>
                {/* &nbsp;&nbsp;|&nbsp;&nbsp;PATRIMÔNIO:&nbsp;
                {formatCurrency(item.wallet?.patrimonioTotal || 0)} */}
              </>
            ) : (
              ""
            )}
          </Typography.Text>
        ) : (
          <Typography.Text className="client-no-plan">
            <FiAlertTriangle size={14} />
            &nbsp;SEM PLANO
          </Typography.Text>
        )}
      </ClientPlanContent>
    );
  };

  const renderIsentCard = (categoria: string) => {
    if (categoria === "Ações" || categoria === "Exterior") {
      const vendas = categoria === "Ações" ? vendasBolsa : vendasExterior;
      const restante =
        categoria === "Ações" ? vendasRestantesBolsa : vendasRestantesExterior;
      const limit = categoria === "Ações" ? 20000 : 35000;
      const tipVendas = vendas
        ? `R$ ${String(
          vendas.toLocaleString("pt-br", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })
        )}`
        : "R$ 0,00";
      const complete = vendas ? (vendas / limit) * 100 : 0;
      return (
        <IsentCardStyled>
          {restante <= 0 ? (
            <Typography.Text className="overviewTitleIsent">
              O seu limite de vendas isentas foi atingido neste mês
            </Typography.Text>
          ) : (
            <Typography.Text className="overviewTitleIsent">
              Você ainda possui{" "}
              <span style={{ fontWeight: "700" }}>
                {formatCurrency(restante)}{" "}
              </span>{" "}
              em vendas isentas em{" "}
              <span style={{ fontWeight: "700" }}>
                {Months[new Date().getMonth()]} {new Date().getFullYear()}
              </span>
            </Typography.Text>
          )}
          <div className="progress_container">
            <Tooltip title={`Vendas no mês: ${tipVendas}`}>
              <div
                className="loading_bar"
                style={{
                  width: `${complete >= 100 ? 100 : complete}%`,
                  borderBottomRightRadius: complete >= 100 ? "50px" : 0,
                  borderTopRightRadius: complete >= 100 ? "50px" : 0,
                }}
              >
                <div className="progress_container_text_align_center">
                  {vendas > 2500 ? formatCurrency(vendas) : ""}
                </div>
              </div>
            </Tooltip>
          </div>
        </IsentCardStyled>
      );
    }
  };

  const downloadExcel = (data: any) => {
    download(proventosFileUrl);
  };

  const monthReport = (data?: any, index?: any) => {
    setOpenModal(true);
    if (data) {
      setMonthProventos(data);
    } else {
      const date = new Date();
      const y = date.getFullYear();
      const m = date.toLocaleString("pt-BR", { month: "short" });
      const name = `${m[0].toUpperCase()}${m.substring(1, 3)}`;
      setMonthProventos({ name });
      setYearProventos(y);
    }
  };

  const handleDarfDownload = async (url?: string, idDarf?: string) => {
    try {
      if (url) {
        window.open(url);
        message.success("Transferência do DARF realizada");
      } else if (idDarf) {
        setLoading(true);
        const token = localStorage.getItem("@VeloTax:token");
        const { data } = await apiBolsa.get(`/darf/download/${idDarf}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        
        if (data?.url) {
          window.open(data.url);
          message.success("Transferência do DARF realizada");
        } else {
          message.error("Erro ao obter URL do DARF");
        }
      }
    } catch (error) {
      console.error("Erro ao baixar DARF:", error);
      message.error("Erro ao baixar DARF. Tente novamente mais tarde.");
    } finally {
      setLoading(false);
    }
  };

  const handleDarfSendAction = async (
    sendToWhatsapp?: boolean,
    directDownload?: boolean,
    sendEmail?: boolean,
    inputClients?: Array<any>
  ) => {
    const firstClient = inputClients?.[0]
    const oldModel = (firstClient?.year ?? 2023) < yearConfigPL4173
    if (oldModel) {
      handleDarfSend(sendToWhatsapp, directDownload, sendEmail, inputClients)
    } else {
      setModalOperationsOpen(false);
      setShowSendDarfModal(true);
    }
  }

  const handleDarfSend = async (
    sendToWhatsapp?: boolean,
    directDownload?: boolean,
    sendEmail?: boolean,
    inputClients?: Array<any>
  ) => {
    try {
      const clients =
        clientsSelected.length > 0 ? clientsSelected : inputClients || [];
      if (whatsappRedirectURL) window.open(whatsappRedirectURL);
      else {
        setLoadingGet(true);
        if (sendToWhatsapp) setWhatsappRedirectURL("loading");
        const { data } = await api.post("/darf/send", {
          clients: clients,
          sendEmail,
          sendToResp,
          sendToWhatsapp,
        });
        const phone = clients[0].phone;
        const singleClient = data[0] || {};
        const shortPath = singleClient?.shortPath;

        const isExterior = singleClient?.type === 'Exterior'
        const oldModel = (singleClient?.year ?? 2023) < yearConfigPL4173
        const darfLabel = isExterior && !oldModel ? 'relatório' : 'DARF'

        if (shortPath && sendToWhatsapp) {
          const text = `Olá, ${singleClient?.name || "Cliente"
            }. Segue seu ${darfLabel} do mês ${singleClient?.month}/${singleClient?.year
            }: ${shortPath}`;
          const url = `https://wa.me${phone ? `/55${phone}` : ""
            }?text=${text.replaceAll(" ", "%20")}`;
          setWhatsappRedirectURL(url);
          window.open(url);
        }
        if (!sendToWhatsapp) {
          if (directDownload) {
            handleDarfDownload(shortPath);
          } else {
            message.success(`Envio de ${darfLabel}s realizado`);
            setShowSendDarfModal(false);
          }
        }
        setSendToResp(false);
        getClients({
          ...filters,
          getAllDarfStatus: true,
          planActive: true,
          fromClients: true,
        });
      }
    } catch (error: any) {
      setWhatsappRedirectURL(undefined);
      if (error.message.includes("400")) {
        message.error(
          "É necessário contratar o plano para prosseguir"
        );
      } else {
        message.error("Algo errado aconteceu, tente novamente mais tarde.");
      }
    }
    setLoadingGet(false);
  };

  const TabProventos = () => {
    const date = new Date();
    const selectYears = [1, 0, -1, -2, -3];
    if (
      selectedClient?.statusBolsa === "Integração inativa" &&
      selectedClient?.statusExterior === "Integração ativa"
    )
      selectYears.splice(0, 1);
    return (
      <ContainerProventos isMobile={isMobile()}>
        <>
          <div className="filter-proventos">
            <Select
              value={yearProventos}
              defaultValue={yearProventos}
              onChange={(e) => setYearProventos(e)}
              options={selectYears.map((y) => ({
                value: date.getFullYear() + y,
                label: date.getFullYear() + y,
              }))}
            />
            <Select
              defaultValue="provento"
              value={typeProventos || "provento"}
              onChange={(e) => setTypeProventos(e)}
              options={[
                {
                  label: "Por tipo de provento",
                  value: "provento",
                },
                {
                  label: "Por corretora",
                  value: "corretora",
                },
                {
                  label: "Por data de recebimento",
                  value: "data",
                },
              ]}
            />
            <div className="client-wallet-header-btns">
              <Button
                icon={<AiOutlineSearch className="fill" />}
                onClick={() => monthReport()}
              >
                Ver detalhes
              </Button>
              <Button
                icon={<HiOutlineDownload />}
                onClick={() => {
                  setReportDrawerProventos(true);
                }}
              >
                Baixar
              </Button>
            </div>
          </div>
          {proventosLoading ? (
            <Loading />
          ) : (
            <ChartBar
              monthReport={monthReport}
              loadingProventos={loadingProventos}
              setLoadingProventos={setLoadingProventos}
            />
          )}
        </>
        <ReportTypeDrawer
          open={reportDrawerProventos}
          loading={loadingGet}
          setType={(type: string) =>
            downloadRelatorio(type, "proventos", proventos)
          }
          onClose={() => setReportDrawerProventos(false)}
        />
      </ContainerProventos>
    );
  };

  const onChangeActiveKeys = (keys: string | string[]) => {
    setActiveKeys(keys as string[]);
    const lastOpened = keys[keys.length - 1];

    let codigo =
      lastOpened?.replaceAll(" ", "").split("-")[3] ||
      lastOpened?.replaceAll(" ", "").split("-")[2];
    let market =
      lastOpened?.replaceAll(" ", "").split("-")[0] ||
      lastOpened?.replaceAll(" ", "").split("-")[1];
    let index = lastOpened?.replaceAll(" ", "").split("-")[1];
    if (
      lastOpened.includes("Imobiliário") ||
      lastOpened.includes("Traded") ||
      lastOpened.includes("Brazilian")
    ) {
      codigo = lastOpened?.replaceAll(" ", "").replace("-", "").split("-")[2];
      index = lastOpened?.replaceAll(" ", "").replace("-", "").split("-")[1];
    }

    if (lastOpened) {
      setDetailedActiveKeys((detailedActiveKeys) => {
        if (
          !detailedActiveKeys.includes(lastOpened) &&
          keys.length > detailedActiveKeys.length
        ) {
          setDetailedLoadingIndex(Number(index));
          api
            .get(`/clients/detalied/${codigo}`, {
              params: {
                exterior:
                  market.toLowerCase() === "exterior" ? true : undefined,
              },
            })
            .then(({ data }) => {
              setDetailedPositions((positions) => [
                ...positions,
                {
                  index,
                  codigo: codigo,
                  details: data,
                },
              ]);
              return [...detailedActiveKeys, lastOpened];
            })
            .finally(() => {
              setDetailedLoadingIndex(undefined);
            });
        }
        return detailedActiveKeys;
      });
    }
  };



  const TabInvestimentos = (
    <Col>


      <Row
        className="client-wallet-header-btns"
        style={{ justifyContent: "flex-end", marginBottom: "12px" }}
      >
        {!loadingGet && selectedClient?.wallet && (
          <Button
            icon={<FiltroIcon />}
            onClick={() => {
              setShowCorretoraFilterModal(true);
            }}
            className={selectedCorretoras.length > 0 ? "filtro-aplicado" : ""}
          >
            Filtrar
          </Button>
        )}
        {!loadingGet && selectedClient?.wallet && (
          <Tooltip title={isMobile() ? "" : "Baixar relatório"}>
            <Button
              icon={<HiOutlineDownload />}
              onClick={() => {
                setReportDrawerWallet(true);
              }}
            />
          </Tooltip>
        )}
        <ReportTypeDrawer
          open={reportDrawerWallet}
          loading={loadingGet}
          setType={(type: string) =>
            downloadRelatorio(type, "patrimônios", selectedClient)
          }
          onClose={() => setReportDrawerWallet(false)}
        />
      </Row>
      <Row className="investimentos-container">
        <Col xs={24} sm={12} className="patrimonio-atual">
          Investimento total:{" "}
          {loadingGet || isLoadingClientData ? (
            <LoadingOutlined style={{ marginLeft: "1rem" }} />
          ) : (
            <Typography.Title level={2}>
              {formatCurrency(
                filterCorretoraAtivo.length > 0 &&
                  filterCorretoraAtivo.length < corretoras.length
                  ? patrimonioFiltrado.patrimonioTotalFiltrado
                  : selectedClient?.wallet?.patrimonioTotal
              )}
            </Typography.Title>
          )}
        </Col>
        <Col xs={24} sm={12} className="lucro-prejuizo-diario-total">
          <div>
            Retorno diário
            <RetornoLabel
              retorno={Number(
                filterCorretoraAtivo.length > 0 &&
                  filterCorretoraAtivo.length < corretoras.length
                  ? patrimonioFiltrado.lucroPrejuizoDiario
                  : selectedClient?.wallet?.lucroPrejuizoDiario || 0
              )}
            >
              {arrow(
                Number(
                  filterCorretoraAtivo.length > 0 &&
                    filterCorretoraAtivo.length < corretoras.length
                    ? patrimonioFiltrado.lucroPrejuizoDiario
                    : selectedClient?.wallet?.lucroPrejuizoDiario || 0
                )
              )}
              {formatCurrency(negativeToPositive(
                Number(
                  filterCorretoraAtivo.length > 0 &&
                    filterCorretoraAtivo.length < corretoras.length
                    ? patrimonioFiltrado.lucroPrejuizoDiario
                    : selectedClient?.wallet?.lucroPrejuizoDiario || 0
                )
              ))}{" "}
              {filterCorretoraAtivo.length > 0 &&
                filterCorretoraAtivo.length < corretoras.length &&
                patrimoniosLoading &&
                (isNaN(
                  patrimonioFiltrado.lucroPrejuizoDiarioPercentualNumerator
                ) ||
                  isNaN(
                    patrimonioFiltrado.lucroPrejuizoDiarioPercentualDenominator
                  )) ? (
                <PatrimonioSemPercentual />
              ) : (
                <>
                  (
                  {arrow(
                    Number(
                      filterCorretoraAtivo.length > 0 &&
                        filterCorretoraAtivo.length < corretoras.length
                        ? patrimonioFiltrado.lucroPrejuizoDiarioPercentualNumerator /
                        patrimonioFiltrado.lucroPrejuizoDiarioPercentualDenominator
                        : selectedClient?.wallet
                          ?.lucroPrejuizoDiarioPercentual || 0
                    )
                  )}
                  {numberToPercentage(negativeToPositive(
                    Number(
                      filterCorretoraAtivo.length > 0 &&
                        filterCorretoraAtivo.length < corretoras.length
                        ? patrimonioFiltrado.lucroPrejuizoDiarioPercentualNumerator /
                        patrimonioFiltrado.lucroPrejuizoDiarioPercentualDenominator
                        : selectedClient?.wallet
                          ?.lucroPrejuizoDiarioPercentual || 0
                    )
                  ))}
                  )
                </>
              )}
            </RetornoLabel>
          </div>
          <div>
            Retorno total
            <RetornoLabel
              retorno={Number(
                filterCorretoraAtivo.length > 0 &&
                  filterCorretoraAtivo.length < corretoras.length
                  ? patrimonioFiltrado.lucroPrejuizoTotal
                  : selectedClient?.wallet?.lucroPrejuizoTotal || 0
              )}
            >
              {arrow(
                Number(
                  filterCorretoraAtivo.length > 0 &&
                    filterCorretoraAtivo.length < corretoras.length
                    ? patrimonioFiltrado.lucroPrejuizoTotal
                    : selectedClient?.wallet?.lucroPrejuizoTotal || 0
                )
              )}
              {formatCurrency(negativeToPositive(
                Number(
                  filterCorretoraAtivo.length > 0 &&
                    filterCorretoraAtivo.length < corretoras.length
                    ? patrimonioFiltrado.lucroPrejuizoTotal
                    : selectedClient?.wallet?.lucroPrejuizoTotal || 0
                )
              ))}{" "}
              {filterCorretoraAtivo.length > 0 &&
                filterCorretoraAtivo.length < corretoras.length &&
                patrimoniosLoading &&
                (isNaN(
                  patrimonioFiltrado.lucroPrejuizoTotalPercentualNumerator
                ) ||
                  isNaN(
                    patrimonioFiltrado.lucroPrejuizoTotalPercentualDenominator
                  )) ? (
                <PatrimonioSemPercentual />
              ) : (
                <>
                  (
                  {arrow(
                    Number(
                      filterCorretoraAtivo.length > 0 &&
                        filterCorretoraAtivo.length < corretoras.length
                        ? patrimonioFiltrado.lucroPrejuizoTotalPercentualNumerator /
                        patrimonioFiltrado.lucroPrejuizoTotalPercentualDenominator
                        : selectedClient?.wallet
                          ?.lucroPrejuizoTotalPercentual || 0
                    )
                  )}
                  {numberToPercentage(negativeToPositive(
                    Number(
                      filterCorretoraAtivo.length > 0 &&
                        filterCorretoraAtivo.length < corretoras.length
                        ? patrimonioFiltrado.lucroPrejuizoTotalPercentualNumerator /
                        patrimonioFiltrado.lucroPrejuizoTotalPercentualDenominator
                        : selectedClient?.wallet
                          ?.lucroPrejuizoTotalPercentual || 0
                    )
                  ))}
                  )
                </>
              )}
            </RetornoLabel>
          </div>
        </Col>
        {/* <Col className="patrimonio-reverse">
          Investimento total em outras corretoras:{" "}
          {loadingGet ? (
            <LoadingOutlined style={{ marginLeft: "1rem" }} />
          ) : (
            <Typography.Title level={2}>
              {formatCurrency(selectedClient?.wallet?.patrimonioReverse)}
            </Typography.Title>
          )}
        </Col> */}
        {!loadingGet && patrimonio && patrimonio.length > 0 && (
          <div style={{
            width: "100%",
            marginTop: "20px",
            marginBottom: patrimonio.length > 5 ? "-40px" : "-50px"
          }}>
            <h2 style={{ marginBottom: "15px", color: '#000000' }}>Distribuição por Corretora:</h2>

            {isMobile() ? (
              <div style={{ width: "100%", marginTop: "20px", marginBottom: "60px" }}>
                <CardsContainer>
                  {patrimonio
                    .sort((a, b) => b.value - a.value)
                    .map((corretora, index) => (
                    <CardCorretora key={index}>
                      <TitleCorretora>{corretora.name}</TitleCorretora>
                      <div style={{ display: "flex", alignItems: "baseline", justifyContent: "center", gap: "5px" }}>
                        <ValueCorretora>{formatCurrency(corretora.value)}</ValueCorretora>
                        <PercentageCorretora>({corretora.percentage}%)</PercentageCorretora>
                      </div>
                    </CardCorretora>
                  ))}
                </CardsContainer>
              </div>
            ) : (
              <CardsContainer>
                {[...patrimonio
                    .sort((a, b) => b.value - a.value), ...Array(9 - patrimonio.length).fill(null)].map((corretora, index) => (
                  <CardCorretora
                    key={index}
                    style={!corretora ? { visibility: "hidden" } : {}}
                  >
                    {corretora && (
                      <>
                        <TitleCorretora>{corretora.name}</TitleCorretora>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "baseline",
                            justifyContent: "center",
                            gap: "5px",
                          }}
                        >
                          <ValueCorretora>{formatCurrency(corretora.value)}</ValueCorretora>
                          <PercentageCorretora>({corretora.percentage}%)</PercentageCorretora>
                        </div>
                      </>
                    )}
                  </CardCorretora>
                ))}
              </CardsContainer>
            )}
          </div>
        )}



        {selectedClient?.wallet ? (
          <>
            <Col span={24} className="grafico-container">
              <ResponsiveContainer >
                <>
                  <div>
                    <PieChart
                      {...(isMobile()
                        ? {
                          width: 330,
                          height: 260,
                        }
                        : {
                          width: 420,
                          height: 300,
                        })}
                    >
                      <Legend
                        align={isMobile() ? "right" : "right"}
                        layout="vertical"
                        iconType="square"
                        verticalAlign="middle"
                        formatter={renderLegend}
                        wrapperStyle={isMobile() ? { marginLeft: isMobile() ? '30px' : '50px', marginTop: '40px' } : {}}
                      />
                      {(chartType === "patrimonio" ||
                        chartType === "posicoes" ||
                        (chartType === "classe" && classesAtivos.length > 0)) && (
                          <Legend
                            align={isMobile() ? "right" : "right"}
                            layout="vertical"
                            iconType="square"
                            verticalAlign="middle"
                            formatter={renderLegend}
                            wrapperStyle={isMobile() ? { marginRight: '10px' } : {}}
                          />
                        )}
                      <Pie
                        cy="50%"
                        cx={isMobile() ? 100 : 150}
                        dataKey="value"
                        fill="#FCC102"
                        innerRadius={isMobile() ? 40 : 50}
                        outerRadius={isMobile() ? 90 : 120}
                        labelLine={false}
                        legendType="circle"
                        label={renderCustomizedLabel}
                        data={
                          chartType === "classe"
                            ? classesAtivos
                            : chartType === "posicoes"
                              ? posicoes
                              : patrimonio
                        }
                      >
                        {(chartType === "classe"
                          ? classesAtivos
                          : chartType === "posicoes"
                            ? posicoes
                            : patrimonio
                        )?.map((entry: any, index: number) => {
                          return (
                            <Cell
                              key={`cell-${index}`}
                              fill={getProviderColor(entry.name, index)}
                            />
                          );
                        })}
                      </Pie>
                      <RechartsTooltip
                        formatter={(value, _, { payload }) => {
                          return `${numberToCurrency(Number(value))} (${String(
                            payload.percentage
                          ).replace(".", ",")}%)`;
                        }}
                      />
                    </PieChart>
                    <div className="select-container">
                      <Select
                        value={chartType}
                        onChange={(value) => setChartType(value)}
                        suffixIcon={<BiChevronDown className="defaultIconSize" />}
                        getPopupContainer={(target) => target.parentElement!}
                      >
                        <Select.Option value="patrimonio">
                          Visualizar por corretora
                        </Select.Option>
                        <Select.Option value="classe">
                          Visualizar classe de ativo
                        </Select.Option>
                        <Select.Option value="posicoes">
                          Visualizar por ativo
                        </Select.Option>
                      </Select>
                    </div>
                  </div>

                </>
              </ResponsiveContainer>
            </Col>



            <Col span={24}>
              <div className="patrimonio-collapse">
                <Collapse
                  expandIconPosition="right"
                  defaultActiveKey={Object.keys(carteiraCategorizada)}
                  expandIcon={({ isActive }) => ExpandIcon({ isActive })}
                >
                  {filterCorretoraAtivo.length === 0
                    ? Object.keys(carteiraCategorizada).map((categoria) => (
                      <Collapse.Panel
                        key={categoria}
                        className="ativos-categoria"
                        header={
                          <>
                            <Typography.Title level={2}>
                              {categoria === "TesouroDireto"
                                ? "Tesouro Direto"
                                : categoria}
                            </Typography.Title>
                            <span className="collapse-title-divider" />
                            <span className="collapse-title-hidden" />
                          </>
                        }
                      >
                        <Collapse
                          activeKey={activeKeys}
                          onChange={onChangeActiveKeys}
                          expandIconPosition="right"
                          expandIcon={({ isActive }) =>
                            ExpandIcon({ isActive })
                          }
                        >
                          {categoria !== "Exterior" && renderIsentCard(categoria)}
                          {carteiraCategorizada[categoria].map(
                            (posicao: any, index: number) => (
                              <Fragment key={`${categoria}-${index}`}>
                                {PosicaoCard({
                                  key: `${categoria}-${index}-${posicao.codigo}`,
                                  posicao,
                                  hideValues,
                                  setHelpModal,
                                  loading: detailedLoadingIndex === index,
                                  cotacaoVenda:
                                    categoria === "Exterior" &&
                                      selectedClient?.wallet?.cotacaoVenda > 0
                                      ? selectedClient?.wallet?.cotacaoVenda
                                      : undefined,
                                  details: detailedPositions?.find(
                                    (el: any) =>
                                      el.codigo === posicao.codigo &&
                                      Number(el.index) === index
                                  )?.details,
                                })}
                              </Fragment>
                            )
                          )}
                        </Collapse>
                      </Collapse.Panel>
                    ))
                    : Object.keys(carteiraCategorizada).map((categoria) => (
                      <Collapse.Panel
                        key={categoria}
                        className="ativos-categoria"
                        header={
                          <>
                            <Typography.Title level={2}>
                              {categoria === "TesouroDireto"
                                ? "Tesouro Direto"
                                : categoria}
                            </Typography.Title>
                            <span className="collapse-title-divider" />
                            <span className="collapse-title-hidden" />
                          </>
                        }
                      >
                        <Collapse
                          activeKey={activeKeys}
                          onChange={onChangeActiveKeys}
                          expandIconPosition="right"
                          expandIcon={({ isActive }) =>
                            ExpandIcon({ isActive })
                          }
                        >
                          {categoria !== "Exterior" && renderIsentCard(categoria)}
                          {carteiraCategorizada[categoria]
                            .filter((item: any) =>
                              filterCorretoraAtivo.includes(item?.corretora)
                            )
                            .map((posicao: any, index: number) => (
                              <Fragment key={`${categoria}-${index}`}>
                                {PosicaoCard({
                                  key: `${categoria}-${index}-${posicao.codigo}`,
                                  posicao,
                                  hideValues,
                                  setHelpModal,
                                  loading: detailedLoadingIndex === index,
                                  cotacaoVenda:
                                    categoria === "Exterior" &&
                                      selectedClient?.wallet?.cotacaoVenda > 0
                                      ? selectedClient?.wallet?.cotacaoVenda
                                      : 0,
                                  details: detailedPositions?.find(
                                    (el: any) =>
                                      el.codigo === posicao.codigo &&
                                      Number(el.index) === index
                                  )?.details,
                                })}
                              </Fragment>
                            ))}
                        </Collapse>
                      </Collapse.Panel>
                    ))}
                </Collapse>

                <Col span={24}>
                  <ul className="patrimonioMessages">
                    <li>
                      <InfoCircleOutlined
                        style={{
                          marginRight: "0.5rem",
                          color: "var(--ant-primary-color)",
                        }}
                      />
                      As posições são atualizadas em até quatro dias úteis após
                      sua negociação (D+4)
                    </li>
                    <li>
                      <InfoCircleOutlined
                        style={{
                          marginRight: "0.5rem",
                          color: "var(--ant-primary-color)",
                        }}
                      />
                      Bonds e/ou operações fora da bolsa de valores não são
                      apresentadas na listagem acima.
                    </li>
                  </ul>
                </Col>
              </div>
            </Col>
          </>
        ) : (
          <Col span={24}>
            <Typography className="list-empty">
              Nenhuma posição encontrada
            </Typography>
          </Col>
        )}
      </Row>
    </Col>
  );

  const TabDarfs = () => {
    const date = new Date();
    const yearsOperations = [0, -1, -2, -3];
    const filteredDarfs = darfs.filter((d) => d?.type === typeDarf);
    

    const darfsToDisplay: any[] =
      !filteredDarfs?.length || !hasPlan
        ? mesesPassados(new Date(yearDarf, 6, 15, 12)).map((m, i) => ({
          month: m,
          year: yearDarf,
          impostoDevido: 0,
        }))
        : filteredDarfs;

    const getDarfs = useCallback((e: number) => {
      setPrevDarfTabClient(selectedClient?.username);
      setDarfLoading(true);
      api
        .get("/clients/allDarf", {
          params: {
            searchText: selectedClient?.username,
            page: 1,
            pageSize: 24,
            year: e,
            username: selectedClient?.username,
            fromClients: true,
          },
        })
        .then((res) => {
          setDarfs(res.data.data);
        })
        .catch(() =>
          message.error(
            "Não foi possível buscar DARFs. Tente novamente mais tarde"
          )
        )
        .finally(() => setDarfLoading(false));
    }, [selectedClient?.username]);

    useEffect(() => {
      if (
        selectedClient?.username !== prevDarfTabClient &&
        currentTab === "darfs"
      ) {
        getDarfs(yearDarf);
      }
    }, [getDarfs, selectedClient?.username, prevDarfTabClient, currentTab, yearDarf]);

 
    return (
      <ConatinerDarfs>
        {!hasPlan && (
          <BlurBox>
            <div className="blur-content-title">
              Contrate o plano premium para ver a lista completa de DARFs
            </div>
          </BlurBox>
        )}
        <FilterDarfs>
          <div className="filterYear">
            <Select
              defaultValue={yearDarf}
              value={yearDarf}
              style={{ width: "100%" }}
              onChange={(e) => {
                getDarfs(e);
                setYearDarf(e);
              }}
              options={yearsOperations.map((y) => ({
                value: date.getFullYear() + y,
                label: date.getFullYear() + y,
              }))}
            />
          </div>
          <div className="buttonFilter">
            {selectedClient?.statusBolsa === "Integração ativa" && (
              <DarfFilterButton
                selected={typeDarf === "Bolsa"}
                onClick={() => setTypeDarf("Bolsa")}
                style={{ marginRight: "8px" }}
              >
                Bolsa de valores
              </DarfFilterButton>
            )}
            {selectedClient?.statusExterior === "Integração ativa" && selectedClient?.integration === "exterior-warren" && (
              <DarfFilterButton
                selected={typeDarf === "Exterior"}
                onClick={() => setTypeDarf("Exterior")}
              >
                Exterior
              </DarfFilterButton>
            )}
          </div>
        </FilterDarfs>
        {darfLoading ? (
          <Loading />
        ) : (
          darfsToDisplay.map((d: any) => {
            const vt = vendasTotais(d) + vendasTotaisExt(d);
            const transactions = d?.transactions;
            const impostoDevido: boolean = d?.impostoDevido >= freeTaxLimit;
            const impostoIsento: boolean =
              d?.type === "Exterior"
                ? d?.vendasTotais > 0
                : d?.impostoDevido !== 0 && d?.vendasTotais > 0;
            const isExterior = d.type === "Exterior"
            const oldModel = yearDarf < yearConfigPL4173
            return (
              <DarfCard>
                <div className="header">
                  <p>{`${monthsExtended[d?.month - 1]} ${d?.year}`}</p>
                  {((isExterior && !oldModel) || (d?.year > 2023 && isExterior)) ? (<></>)
                    : d?.darfPago && impostoDevido ? (
                      <button className="payed">
                        Pago <BiCheck />{" "}
                      </button>
                    ) : impostoDevido ? (
                      <button>Em aberto</button>
                    ) : (
                      <></>
                    )}
                  {(d?.year > 2023 && isExterior) && <div className="action-view">
                    <Button
                      onClick={() => {
                        setDarfSelected([d]);
                        setModalOperationsOpen(true);
                      }}
                    >
                      <BsEye />
                      {!isMobile() && "Visualizar"}
                    </Button>
                  </div>}
                </div>
                {/* {((d?.year <= 2023 && isExterior) || !isExterior) && <Divider style={{ margin: "8px 0" }} />} */}
                <Divider style={{ margin: "8px 0" }} />
                {(d?.year > 2023 && isExterior) && <div className="body">
                  {transactions?.length ? 'Há movimentações neste mês' : "Sem movimentações"}
                </div>}
                {((d?.year <= 2023 && isExterior) || !isExterior) && <div className="body">
                  {impostoIsento || transactions?.length > 0 ? (
                    <div className="resumo">
                      <p>
                        Vendas totais:{" "}
                        <strong>{formatCurrency(d?.vendasTotais ?? vt)}</strong>
                      </p>
                      <p>
                        Imposto a pagar:{" "}
                        <strong>
                          {d?.impostoDevido <= 0
                            ? "Isento"
                            : formatCurrencySmart(d?.impostoDevido)}
                        </strong>
                      </p>
                      {impostoDevido && (!isExterior || oldModel) && (
                        <p>
                          Vencimento:{" "}
                          <strong>
                            {moment({ year: d?.year, month: d?.month - 1 })
                              .add(1, "month")
                              .endOf("month")
                              .format("DD/MM/YYYY")}
                          </strong>
                        </p>
                      )}
                    </div>
                  ) : (
                    <div className="resumo">
                      <p className="empty">
                        Não houve movimentações tributáveis neste mês.
                      </p>
                    </div>
                  )}
                  <div className="actions">
                    {
                      impostoDevido && typeDarf === "Bolsa" && (thirdBusinessDayAndMonth(d).disabled || shouldBlockDarfSend(d))
                        ?
                        <Tooltip
                          placement="topRight"
                          open={showDarfTooltip}
                          title={shouldBlockDarfSend(d) ? "Aguarde o sexto dia útil deste mês, para visualizar seu DARF" : thirdBusinessDayAndMonth(d).title}
                        >
                          <Button
                            block
                            tooltip
                            onClick={() => {
                              setShowDarfTooltip(!showDarfTooltip)

                              setTimeout(() => {
                                setShowDarfTooltip(false)
                              }, 1500);
                            }}
                          >
                            Enviar
                          </Button>
                        </Tooltip>
                        :
                        impostoDevido
                          ?
                          <Button
                            block
                            disabled={thirdBusinessDayAndMonth(d).disabled || shouldBlockDarfSend(d)}
                            size="large"
                            type="primary"
                            onClick={() => {
                              setDarfSelected([d]);
                              setShowSendDarfModal(true);
                            }}
                          >
                            {isExterior && !oldModel ? 'Enviar relatório' : "Enviar"}
                          </Button>
                          :
                          null
                    }
                    <Button
                      onClick={() => {
                        setDarfSelected([d]);
                        setModalOperationsOpen(true);
                      }}
                    >
                      <BsEye />
                      {!impostoDevido && "Visualizar"}
                    </Button>
                  </div>
                </div>}
              </DarfCard>
            );
          })
        )}
      </ConatinerDarfs>
    );
  };



  // Hook otimizado para verificação de planos com cache inteligente
  // Evita recálculos desnecessários e melhora a responsividade do modal

  const { hasPlan, temAvisos, temIntegracaoBolsa, temIntegracaoExterior } = usePlanVerification(
    selectedClient as unknown as IClient | null
  );


  const isAuthorized = selectedClient?.code?.[0]?.isAuthorized;

  const mostrarTabs = true;
  // hasPlan &&
  // (selectedClient?.statusBolsa === "Integração ativa" ||
  //   selectedClient?.statusExterior === "Integração ativa");

  return (
    <Container>
      <SideContent>
        <Row gutter={[16, { xs: 12, sm: 8 }]} style={{ rowGap: "28px" }}>
          <Col span={14}>
            <Typography.Title level={1} className="app-title">
              Meus clientes
            </Typography.Title>
          </Col>
          <Col span={10}>
            <Button
              block
              size="large"
              type="primary"
              icon={<BiPlusCircle style={{ fill: "#FFFFFF" }} />}
              onClick={setOptionsModalVisibility}
              style={{ borderRadius: "6px" }}
            >
              Adicionar
            </Button>
          </Col>
          <Col hidden={true}>
            <Typography.Text>
              Investimento total:{" "}
            </Typography.Text>
            {loadingGet ? (
              <LoadingOutlined style={{ marginLeft: "1rem" }} />
            ) : (
              <Typography.Title level={2} style={{ marginTop: "0px", marginBottom: "0px" }}>
                {formatCurrency(totalPatrimonio || 0)}
              </Typography.Title>
            )}
          </Col>
          <Col hidden={true} className="patrimonio-reverse-total">
            <Typography.Text>
              Investimento total em outras corretoras:{" "}
            </Typography.Text>
            {loadingGet ? (
              <LoadingOutlined style={{ marginLeft: "1rem" }} />
            ) : (
              <Typography.Title level={4} style={{ marginTop: "0px", marginBottom: "0px" }}>
                {formatCurrency(totalPatrimonioReverse || 0)}
              </Typography.Title>
            )}
          </Col>
          <Col span={24}>
            <SearchInputClients>
              <Input
                size="large"
                placeholder="Buscar cliente..."
                prefix={<AiOutlineSearch size={20} />}
                onChange={(e) => handleSearch(e.target.value)}
                className="clients-search-input"
              />
            </SearchInputClients>
          </Col>
          <Col span={24} className="ant-col-clients-table">
            <Table
              rowKey="username"
              loading={loadingGet}
              dataSource={clients}
              rowClassName={(item) =>
                item.userId === selectedClient?.userId ? "selected-client" : ""
              }
              rowSelection={{
                selectedRowKeys: keys,
                onChange: (_: any, selectedRows) => {
                  setClientsSelected(selectedRows);
                  setShowUpgradePlan(false);
                  setKeys((selectedRows ?? []).map((el) => el.username));
                },
                getCheckboxProps: (record: any) => ({
                  disabled: handleDisabled(record),
                }),
              }}
              pagination={{
                defaultPageSize: 10,
                total: totalClients,
                defaultCurrent: 1,
                showLessItems: true,
                showSizeChanger: false,
                simple: windowWidth <= 812, // Usar paginação simples em mobile
                size: windowWidth <= 812 ? 'small' : 'default', // Tamanho menor em mobile
                showQuickJumper: false,
                showTotal: windowWidth <= 812 ? (total, range) => `${range[0]}-${range[1]} de ${total} itens` : undefined, // Mostrar total apenas em mobile
                responsive: true,
                hideOnSinglePage: false, // Forçar exibição mesmo com uma página
              }}
              onChange={(pagination) => {
                setCurrentPage(pagination.current ?? 1);
                getClients({
                  searchText,
                  page: pagination.current,
                  pageSize: pagination.pageSize,
                  resp: (appliedFilters.resp || []) as string[],
                  statusBolsa: appliedFilters.statusBolsa as CalcStatus[],
                  planActive: (appliedFilters.planActive || []) as string[],
                  statusExterior: appliedFilters.statusExterior as CalcStatus[],
                });
              }}
              columns={[
                {
                  title: (
                    <>
                      <div className="client-table-header">
                        <span>Selecionar todos</span>
                        <div className="client-table-header-btns">
                          <Button
                            icon={<FiltroIcon />}
                            onClick={handleOpenFilterModal}
                            className={
                              Object.keys(appliedFilters).filter(
                                (key) => (appliedFilters[key]?.length || 0) > 0
                              ).length > 0
                                ? "filtro-aplicado"
                                : ""
                            }
                          >
                            Filtrar
                          </Button>
                          {clients.length > 0 && (
                            <Tooltip title="Baixar planilha">
                              <Button
                                icon={<HiOutlineDownload />}
                                onClick={() => handleDownloadSheet("Clientes")}
                              />
                            </Tooltip>
                          )}
                          {clients.length > 0 && false && (
                            <Tooltip title="Atualizar patrimônios">
                              <Button
                                icon={<GrUpdate className="fill" />}
                                onClick={() => {
                                  setUpdateAllPatrimonio(true);
                                  setPatrimonioModalVisible(true);
                                }}
                              />
                            </Tooltip>
                          )}
                        </div>
                      </div>
                    </>
                  ),
                  render: (_, item) => (
                    <Row
                      onClick={async () => {
                        setIsLoadingClientData(true);
                        setSelectedClient(item);
                        setVisibleChart(false);
                        setVisibleTabs(false);
                        handleSelectedTab(item);
                        setActiveKeys([]);
                        setDetailedPositions([]);
                        setDetailedActiveKeys([]);
                        setCheckboxCorretoras([]);
                        setSelectedCorretoras([]);
                        setFilterCorretoraAtivo([]);

                        // Aguarda o carregamento do patrimônio antes de mostrar as abas
                        try {
                          // Sempre chama handleUpdatePatrimonio
                          await handleUpdatePatrimonio(item);

                          // Mostra as abas após o carregamento e seleciona a primeira aba (carteira)
                          setTimeout(() => {
                            setVisibleChart(true);
                            setVisibleTabs(true);
                            setCurrentTab("investimentos"); // Sempre seleciona a primeira aba
                            setIsLoadingClientData(false); // Reset loading state
                          }, 300);
                        } catch (error) {
                          // Em caso de erro, ainda mostra as abas e seleciona a primeira
                          setTimeout(() => {
                            setVisibleChart(true);
                            setVisibleTabs(true);
                            setCurrentTab("investimentos"); // Sempre seleciona a primeira aba
                            setIsLoadingClientData(false); // Reset loading state
                          }, 300);
                        }
                      }}
                    >
                      <Col span={24} style={{ position: "relative" }}>
                        <Typography.Text className="client-name">
                          {item.name}
                          {handleDisabled(item) ? (
                            <Col span={1}>
                              <Tooltip title={tooltip}>
                                <InfoCircleOutlined />
                              </Tooltip>
                            </Col>
                          ) : item.planActive ? (
                            <SeloIcon />
                          ) : (
                            <></>
                          )}
                        </Typography.Text>
                      </Col>
                      <Col span={24}>
                        <ClientPlan item={item as any} />
                      </Col>
                      <Col span={24} className="client-integration">
                        {item.statusBolsa !== "Integração ativa" ? (
                          <Tag className="no-integration">Inativo Bolsa</Tag>
                        ) : (
                          <Tag className="has-integration">
                            Ativo Bolsa
                            {/* {item.updatingB3Integration && (
                              <div className="integration-indicator">
                                <Tooltip title="Atualizando integração com a B3">
                                  <SyncOutlined spin />
                                </Tooltip>
                              </div>
                            )} */}
                            {/* {item.b3IntegrationUpdated && (
                              <div className="integration-indicator">
                                <Tooltip title="Integração com a B3 atualizada">
                                  <BsCheck2Circle
                                    style={{
                                      fill: "var(--ant-success-color)",
                                      fontSize: "12px",
                                    }}
                                  />
                                </Tooltip>
                              </div>
                            )} */}
                          </Tag>
                        )}
                        {/* {item.statusExterior !== "Integração ativa" ? (
                          <Tag className="no-integration">Inativo Exterior</Tag>
                        ) : (
                          <Tag className="has-integration">Ativo Exterior</Tag>
                        )} */}
                      </Col>
                      {(item?.planActive ||
                        moment(new Date(item?.planDueDate || 2021)).isAfter(
                          moment(new Date())
                        )) &&
                        (item?.notifications?.filter((n) => !n.viewed)
                          ?.length || 0) > 0 && (
                          <div
                            className={`client-notification ${(item?.notifications?.filter((n) => !n.viewed)
                              ?.length || 0) >= 100
                              ? "large"
                              : ""
                              }`}
                          >
                            <span>
                              {(item?.notifications?.filter((n) => !n.viewed)
                                ?.length || 0) >= 100
                                ? "+99"
                                : item?.notifications?.filter((n) => !n.viewed)
                                  ?.length}
                            </span>
                          </div>
                        )}
                    </Row>
                  ),
                },
              ]}
            />
          </Col>
        </Row>
        {clientsSelected.length > 0 && (
          <div className="mobile-actions">
            <Button
              block
              type="primary"
              onClick={() => {
                setShowMobileActionSelectedClients(true);
              }}
            >
              Ações
            </Button>
          </div>
        )}
      </SideContent>
      <Content
        className={clsx("beauty-scrollbar", {
          "mobile-show":
            (clients?.length > 0 && selectedClient) ||
            (clientsSelected.length > 0 && showMobileActionSelectedClients),
        })}
      >
        {clients?.length === 0 ? (
          <EmptyContainer>
            <EmptyIcon />
            <Typography.Title level={1}>
              Olá, {user.user.name}!
            </Typography.Title>
            <Typography.Paragraph>
              Para iniciar, adicione e selecione clientes na lista ao lado para
              visualizar mais detalhes.
            </Typography.Paragraph>
          </EmptyContainer>
        ) : selectedClient && !clientsSelected.length ? (
          <ClientContainer>
            <div className="client-actions">
              {!handleDisabled(selectedClient) ? (
                <Button
                  loading={loadingLogin}
                  icon={loadingLogin ? <LoadingOutlined /> : <FiExternalLink />}
                  onClick={() => {
                    loginInClient(selectedClient);
                  }}
                >
                  Acessar conta
                </Button>
              ) : (
                <Button
                  loading={loadingLogin}
                  icon={
                    loadingLogin ? (
                      <LoadingOutlined />
                    ) : (
                      <MdOutlineMailOutline />
                    )
                  }
                  onClick={() => {
                    sendPermissionEmail(selectedClient);
                  }}
                >
                  Reenviar solicitação de acesso
                </Button>
              )}
              <Dropdown
                disabled={loadingGet}
                trigger={["click"]}
                menu={{
                  items: handleDisabled(selectedClient)
                    ? [
                      {
                        key: "remover",
                        label: "Remover",
                        icon: <BsTrash className="icon-card" />,
                        onClick: () => handleRemoveModal(selectedClient),
                      },
                    ]
                    : [
                      {
                        key: "editar",
                        label: "Editar",
                        icon: <FaRegEdit className="icon-card" />,
                        onClick: () => handleEdit(selectedClient),
                      },
                      {
                        key: "remover",
                        label: "Remover",
                        icon: <BsTrash className="icon-card" />,
                        onClick: () => handleRemoveModal(selectedClient),
                      },
                      {
                        key: "patrimonio",
                        label: "Atualizar Patrimônio",
                        icon: <FiRefreshCw className="icon-card" />,
                        onClick: () => handleUpdatePatrimonio(selectedClient),
                      },
                    ],
                }}
              >
                <Button
                  icon={<BsThreeDotsVertical />}
                  onClick={(e) => e.preventDefault()}
                />
              </Dropdown>
              <Button
                className="close-client"
                icon={<AiOutlineClose />}
                onClick={() => {
                  setSelectedClient(null);
                  setIsLoadingClientData(false);
                  setActiveKeys([]);
                  setDetailedPositions([]);
                  setDetailedActiveKeys([]);
                }}
              />
            </div>
            <div className="client-content">
              <div className="client-header">
                {(selectedClient?.planActive ||
                  moment(new Date(selectedClient?.planDueDate || 2021)).isAfter(
                    moment(new Date())
                  )) && (
                    <div className="notification-button">
                      <Badge
                        size="small"
                        count={
                          (notificacoes || []).filter((n) => !n.viewed).length
                        }
                        showZero={false}
                        offset={[-12, 48]}
                      >
                        <Button
                          loading={false}
                          icon={<BiBell />}
                          onClick={() => {
                            setNotificationDrawerOpen(true);
                          }}
                        />
                      </Badge>
                    </div>
                  )}
                <Typography.Title level={1}>
                  <div style={{
                    display: 'inline',
                    maxWidth: 'calc(100% - 60px)' // Reserva espaço para o ícone de notificação
                  }}>
                    <span style={{
                      wordBreak: 'break-word',
                      display: 'inline'
                    }}>
                      {selectedClient.name}
                    </span>
                    {selectedClient.planActive && (
                      <Tooltip
                        title={getPlan(selectedClient)}
                      >
                        <SeloIcon style={{
                          display: 'inline',
                          marginLeft: '4px',
                          verticalAlign: 'middle'
                        }} />
                      </Tooltip>
                    )}
                  </div>
                </Typography.Title>
                
                {/* Exibir acessores do cliente */}
                <Responsaveis item={selectedClient} />


     

                {/* Seção de patrimônio sempre visível, mas com funcionalidades condicionais */}
                {selectedClient.wallet && (
                  <Typography.Paragraph>
                    <ClientPlanContent>
                      <Row align="middle" gutter={16}>
                        {!loadingGet && (
                          <Col>
                            <Typography.Text className="last-update">
                              <Tooltip title={
                                !hasPlan
                                  ? "Cliente sem plano ativo"
                                  : !selectedClient.wallet?.patrimonioTotal
                                    ? "Sem dados de patrimônio disponíveis"
                                    : "Atualizar Patrimônio"
                              }>
                                <Button
                                  type="link"
                                  size="small"
                                  icon={<GrUpdate />}
                                  loading={loadingGet}
                                  className="button-refresh-wallet"
                                  onClick={() => handleUpdatePatrimonio(selectedClient)}
                                />
                              </Tooltip>
                              {selectedClient?.wallet ? (
                                  new Date().toLocaleString()
                              ) : '-'}
                            </Typography.Text>
                          </Col>
                        )}
                        <Col>
                          <Typography.Text className="client-plan">
                            PATRIMÔNIO:&nbsp;
                             {isLoadingClientData ? (
                               <LoadingOutlined spin style={{ 
                                 marginLeft: 8, 
                                 verticalAlign: 'middle',
                                 marginTop: -10
                               }} />
                        
                              ) : (
                              formatCurrency(
                                selectedClient?.wallet?.patrimonioTotal || 0
                              )
                            )}
                            &nbsp;
                            {/* <GrDocumentUpload
                              className="fill"
                              style={{
                                opacity: selectedClient.wallet?.patrimonioTotal ? "0.5" : "0.2",
                                cursor: selectedClient.wallet?.patrimonioTotal ? "pointer" : "not-allowed",
                                margin: "2px 0 0 0",
                              }}
                              onClick={() => {
                                if (selectedClient.wallet?.patrimonioTotal) {
                                  setClientsSelected([{ ...selectedClient }]);
                                  getHistory(selectedClient.username);
                                  setShowNotasCorretagemModal(true);
                                }
                              }}
                            /> */}
                          </Typography.Text>
                        </Col>
                      </Row>
                      {/* {selectedClient.updatingB3Integration && (
                        <Typography.Text className="client-plan">
                          <div>
                            <SyncOutlined
                              spin
                              style={{ marginRight: "8px" }}
                            />
                            Atualizando integração com a B3
                          </div>
                        </Typography.Text>
                      )} */}
                      {/* {selectedClient.b3IntegrationUpdated && (
                        <Typography.Text className="client-plan">
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <BsCheck2Circle
                              style={{ marginRight: "8px", fontSize: "12px" }}
                            />
                            Integração com a B3 atualizada
                          </div>
                        </Typography.Text>
                      )} */}
                    </ClientPlanContent>
                  </Typography.Paragraph>
                )}
              </div>
              <Row gutter={[24, 24]} className="client-info">

                {selectedClient.phone && (
                  <Col>
                    <div className="client-info-title">Telefone:</div>
                    <div className="client-info-data">
                      {numberToPhone(selectedClient.phone)}
                    </div>
                  </Col>
                )}
                <Col>
                  <div className="client-info-title">CPF:</div>
                  <div className="client-info-data">
                    {maskCpf(selectedClient.username)}
                  </div>
                </Col>
                <Col>
                  <div className="client-info-title">E-mail:</div>
                  <div className="client-info-data">{selectedClient.email}</div>
                </Col>
                {user.user.office || user?.user?.admin || user?.user?.liberadaContratacao ? (
                  <Col>
                    <div className="client-info-title">
                      Concierge responsável:
                    </div>
                    <div className="client-info-data">
                      {user?.user?.liberadaContratacao ? (
                        <a
                          target="_blank"
                          rel="noreferrer"
                          className="concierge"
                          href={`https://wa.me/55${user.user.responsavel?.phone}`}
                        >
                          <span className="dashed">
                            {user.user.responsavel?.name}
                          </span>{" "}
                          <WhatsAppOutlined />
                        </a>
                      ) : !user?.user?.liberadaContratacao ? (
                        <a
                          target="_blank"
                          rel="noreferrer"
                          className="ativar-concierge"
                          href="mailto:parcerias@velotax.com.br"
                        >
                          <span className="dashed">Ativar concierge</span>{" "}
                          <MdEmail size={16} />
                        </a>
                      ) : (
                        "-"
                      )}
                    </div>
                  </Col>
                ) : (
                  <></>
                )}
                {handleVencimento(selectedClient) ? (
                  <Col>
                    <div className="client-info-title">Vencimento:</div>
                    <div className="client-info-data">
                      {handleVencimento(selectedClient)}
                    </div>
                  </Col>
                ) : (
                  <></>
                )}
              </Row>
              {hasPlan && temAvisos && !isLoadingClientData && (
                <Avisos
                  setOpen={setOpen}
                  setPaymentType={setPaymentType}
                  selectedPlan={selectedPlan}
                  setSelectedPlan={setSelectedPlan}
                  setShowPaymentModal={setShowPaymentModal}
                  clientsWithCancelRecurring={clientsSelected.filter(
                    (client) => client.cancelRecuring
                  )}
                  setIntegrationModal={setIntegrationModal}
                  setIntegrationClient={setIntegrationClient}
                  setClientsSelected={setClientsSelected}
                  filters={{ ...filters, page: currentPage }}
                />
              )}
              {mostrarTabs && !handleDisabled(selectedClient) && (
                <div className="client-details">
                  {!visibleTabs ? (
                    <div className="client-details-loading">
                      <LoadingOutlined />
                    </div>
                  ) : (
                    <Tabs
                      activeKey={currentTab}
                      onChange={(key) => {
                        setCurrentTab(key);
                        if (key === "darfs") {
                          setTypeDarf(
                            (typeDarf === "Exterior" &&
                              (selectedClient?.statusExterior !==
                              "Integração ativa" || !selectedClient || (selectedClient as any).integration !== "exterior-warren")) ||
                              selectedClient?.statusBolsa === "Integração ativa"
                              ? "Bolsa"
                              : "Exterior"
                          );
                        } else {
                          setVisibleChart(false);
                          setTimeout(() => {
                            setVisibleChart(true);
                          }, 100);
                        }
                      }}
                      items={
                        !visibleTabs || !isAuthorized
                          ? []
                          : [
                            ...(temInvestimentos
                              ? [
                                {
                                  key: "investimentos",
                                  label: (
                                    <div className="tab-title">
                                      Carteira {!hasPlan && <BiLock />}
                                    </div>
                                  ),
                                  children: hasPlan ? (
                                    TabInvestimentos
                                  ) : (
                                    // : TabInvestimentosSemPlano,
                                    <></>
                                  ),
                                },
                                {
                                  key: "proventos",
                                  label: (
                                    <div className="tab-title">
                                      Proventos {!hasPlan && <BiLock />}
                                    </div>
                                  ),
                                  children: hasPlan ? (
                                    <TabProventos />
                                  ) : (
                                    // <TabProventosSemPlano />
                                    <></>
                                  ),
                                },
                              ]
                              : []),
                            ...(isAuthorized
                              ? [
                                {
                                  key: "darfs",
                                  label: (
                                    <div className="tab-title">
                                      DARFs {!hasPlan && <BiLock />}
                                    </div>
                                  ),
                                  children: hasPlan ? <TabDarfs /> : <></>,
                                },
                                {
                                  key: "previdencia",
                                  label: "Previdência",
                                  children: <Previdencia />,
                                },
                              ]
                              : []),
                          ]
                      }
                    />
                  )}
                </div>
              )}
              {!hasPlan && currentTab !== "previdencia" && !isLoadingClientData && (
                <Avisos
                  setOpen={setOpen}
                  setPaymentType={setPaymentType}
                  selectedPlan={selectedPlan}
                  setSelectedPlan={setSelectedPlan}
                  setShowPaymentModal={setShowPaymentModal}
                  clientsWithCancelRecurring={clientsSelected.filter(
                    (client) => client.cancelRecuring
                  )}
                  setIntegrationModal={setIntegrationModal}
                  setIntegrationClient={setIntegrationClient}
                  setClientsSelected={setClientsSelected}
                  filters={{ ...filters, page: currentPage }}
                />
              )}
            </div>
          </ClientContainer>
        ) : (clientsToUpgrade.length === 1 && showUpgradePlan) || (selectedClient && showUpgradePlan) ? (
          <PlanContainer >
            <Planos hasPlan={{
              basic: selectedClient?.planName?.includes('BASIC') || false,
              premium: selectedClient?.planName?.includes('PRO') || false,
              concierge: selectedClient?.planName?.includes('CONCIERGE') || false
            }} selectedClient={selectedClient}
              onBack={() => { setShowUpgradePlan(false) }}
              onFinish={() => {
                setShowUpgradePlan(false);
                setCurrentTab('investimentos');
                setClientsSelected([]);

              }} />
          </PlanContainer>
        ) : (
          <EmptyContainer>
            <Button
              type="text"
              className="close-selection"
              icon={<AiOutlineClose />}
              onClick={() => {
                setShowMobileActionSelectedClients(false);
              }}
            />
            <SelectionIcon />
            <Typography.Title level={1}>
              {clientsSelected.length} cliente
              {clientsSelected.length > 1 ? "s" : ""}{" "}
              <span style={{ fontWeight: 100 }}>
                selecionado{clientsSelected.length > 1 ? "s" : ""}
              </span>
            </Typography.Title>
            <Typography.Paragraph>
              Selecione abaixo qual ação deseja realizar:
            </Typography.Paragraph>
            <Row
              gutter={[16, 16]}
              align="middle"
              justify="center"
              className="action-buttons"
            >
              <div style={{width: "100%", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", gap: "16px" }}>
              <Col xs={24} sm={12}>
                <Button
                  block
                  size="large"
                  type="primary"
                  icon={<MailOutlined />}
                  disabled={clientsSelected.length === 0}
                  onClick={() => setSendMailModalVisible(true)}
                >
                  ENVIAR LEMBRETE
                </Button>
              </Col>
              <Col xs={24} sm={12}>
                <Button
                  block
                  type="text"
                  size="large"
                  className="btn-underlined"
                  onClick={() => {
                    setKeys([]);
                    setClientsSelected([]);
                    setShowMobileActionSelectedClients(false);
                  }}
                >
                  Limpar seleção
                </Button>
              </Col>
              </div>
            </Row>
          </EmptyContainer>
        )}
        <DeleteConfirmationModal
          title="Remover cliente"
          body="Tem certeza que deseja remover este cliente?"
          visibility={deleteModalVisible}
          onCancel={() => {
            setDeleteModalVisible(false);
          }}
          setVisibility={setDeleteModalVisiblity}
          onOk={() => removeClient(currentPage)}
        />
        <FormModal
          title={newClient ? "Editar cliente" : "Adicionar cliente"}
          itemToEdit={
            newClient
              ? {
                ...newClient,
                assessores: assessoresSelected,
                plan: newClient?.planType || "free",
              }
              : null
          }
          visibility={createModalVisible}
          rows={ClientFormItemRows({
            user,
            step: 1,
            professionals,
            client: newClient,
            handleChangeAssessores,
            assessores: assessoresSelected,
            onBlur: onInputBlur,
            userSelected,
          }).filter((input) => {
            // Se ele não for escritório ou manager, não mostra o input de plano
            if (!isManagerOrOffice && input[0]?.name === "plan") {
              return false;
            }
            return true;
          })}
          onCancel={() => {
            // getClients({
            //   ...filters,
            //   searchText: searchText.length > 0 ? searchText : null,
            //   page: currentPage,
            // });
            setUserSelected({});
            setCreateModalVisible(false);
          }}
          add={(data: any) => {
            createClient(
              {
                plan: "free",
                ...data,
                assessores:
                  user.user.office || user?.user?.admin
                    ? data.assessores
                    : [user.user.assessorId],
              },
              currentPage
            );
            setCreateModalVisible(false);
            setClientsSelected([]);
            setKeys([]);
          }}
          edit={(data: any) => {
            if (!user?.user?.office && !user?.user?.admin) {
              data.assessores = (userSelected?.resp || []).map(
                (r: any) => r._id
              );
            }
            updateClient(
              {
                ...data,
                plan: userSelected?.planType || "free",
                userId: newClient?.userId,
              },
              currentPage,
              filters
            );
            setCreateModalVisible(false);
            setSelectedClient(null);
            setKeys([]);
          }}
        />
        <UserPlanModal
          width="50%"
          open={open}
          setOpen={setOpen}
          closeModal={handlePlan}
          paymentType={paymentType}
          onCancel={() => handlePlan()}
          setPaymentType={setPaymentType}
          clientsSelected={clientsSelected}
          selectedPlan={selectedPlan}
          setSelectedPlan={setSelectedPlan}
          showPaymentModal={showPaymentModal}
          setClientsSelected={setClientsSelected}
          setShowPaymentModal={setShowPaymentModal}
          createConciergePlan={createPlanFromSelectedUsers}
          userCount={
            clientsSelected.filter((client) => !client.planActive).length
          }
          clientsWithCancelRecurring={clientsSelected.filter(
            (client) => client.cancelRecuring
          )}
        />
        <Modal
          footer={null}
          visible={showNotasCorretagemModal}
          title="Carregar notas de corretagem"
          className="modalNotasCorretagem"
          onCancel={() => {
            if (!loadingSend) {
              setShowNotasCorretagemModal(false);
              setFiles([]);
              setClientsSelected([]);
            }
          }}
        >
          <Typography.Text style={{ fontSize: "14px", color: "var(--gray-2)" }}>
            <AiFillInfoCircle
              style={{
                width: "16px",
                height: "16px",
                transform: "translateY(3px)",
                marginRight: "4px",
              }}
            />
            Você pode também adicionar as notas de corretagem caso queira
            verificar o imposto de renda sobre operações realizadas fora do
            ambiente B3.
          </Typography.Text>
          <UploadNotas loading={loadingSend} {...uploadProps} />
          <Typography.Title level={5} style={{ fontWeight: "500" }}>
            Histórico de notas
          </Typography.Title>
          <Table
            rowKey="id"
            loading={loadingGet || loadingSend}
            dataSource={history}
            pagination={{
              defaultPageSize: 5,
              total: history.length,
              defaultCurrent: 1,
              simple: true,
            }}
            onChange={(pagination, filters) => {
              const filtros: any = filters;
              getHistory(clientsSelected[0].username, { filters: filtros });
            }}
            locale={{
              filterReset: "Limpar",
            }}
            columns={[
              {
                align: "center",
                title: "Dia",
                dataIndex: "day",
                filterIcon: <IoMdOptions className="defaultIconSize" />,
                filters: dayFilters,
                render: (status, item) => <>{status}</>,
              },
              {
                align: "center",
                title: "Mês",
                dataIndex: "month",
                filterIcon: <IoMdOptions className="defaultIconSize" />,
                filters: monthsExtended.map((m, i) => ({
                  text: m,
                  value: i + 1,
                })),
                render: (status, item) => <>{status}</>,
              },
              {
                align: "center",
                title: "Ano",
                dataIndex: "year",
                filterIcon: <IoMdOptions className="defaultIconSize" />,
                filters: yearFilters,
                render: (status, item) => <>{status}</>,
              },
              {
                className: "actionColumn",
                render: (status, item) => (
                  <Button
                    onClick={() =>
                      downloadNota(item.path, item.month, item.year)
                    }
                  >
                    Ver nota
                  </Button>
                ),
              },
            ]}
          />
          {files?.length > 0 && (
            <>
              <Row justify="end" style={{ marginTop: "1rem" }}>
                <Typography.Text
                  style={{ fontSize: "13px", color: "var(--gray-2)" }}
                >
                  Lembre-se de clicar em finalizar para salvar seus dados
                </Typography.Text>
                <Button
                  type="primary"
                  disabled={loadingSend}
                  style={{ margin: "1rem 0" }}
                  size="large"
                  onClick={() => sendNotas(clientsSelected[0].username)}
                >
                  Finalizar
                </Button>
              </Row>
            </>
          )}
        </Modal>
        <Modal
          footer={null}
          title={selectedNotificationType?.label() || "Enviar lembrete"}
          visible={sendMailModalVisible}
          onCancel={() => {
            setSelectedNotificationType(undefined);
            setSendMailModalVisible(false);
          }}
        >
          <Row gutter={[16, 16]}>
            {!selectedNotificationType ? (
              <>
                <Col span={24}>
                  <Typography>
                    Escolha qual dos lembretes abaixo deseja enviar para{" "}
                    {clientsSelected.length > 1 ? (
                      <b>os {clientsSelected.length} clientes selecionados</b>
                    ) : (
                      "o cliente selecionado"
                    )}
                  </Typography>
                </Col>
                {mailTypes.map((mailType) => (
                  <Col sm={12} xs={24} key={mailType.value}>
                    <Card
                      className="lembretes"
                      onClick={() => {
                        if (clientsSelected.length > 1) {
                          sendMail(mailType.value);
                        } else {
                          setSelectedNotificationType(mailType);
                        }
                      }}
                    >
                      <Row>{mailType.icon()}</Row>
                      {mailType.label()}
                    </Card>
                  </Col>
                ))}
              </>
            ) : (
              <>
                <Col span={24}>
                  <Typography>
                    Escolha a forma que deseja enviar o lembrete para o cliente:
                  </Typography>
                </Col>
                <Col sm={12} xs={24}>
                  <Card
                    className="lembretes"
                    onClick={() => {
                      sendMail(selectedNotificationType.value);
                    }}
                  >
                    <Row>
                      <MdOutlineMailOutline
                        style={{
                          marginBottom: "20px",
                          width: "30px",
                          height: "30px",
                          color: "var(--yellow)",
                        }}
                      />
                    </Row>
                    Enviar lembrete por <strong>E-mail</strong>
                  </Card>
                </Col>
                <Col sm={12} xs={24}>
                  <Card
                    className="lembretes"
                    onClick={() => {
                      const text = `${selectedNotificationType.whatsappMessage.replaceAll(
                        " ",
                        "%20"
                      )}${selectedNotificationType.link}`;
                      const clientWithPhone = clientsSelected.find(
                        (c) => !!c.phone
                      );
                      const phoneParam = clientWithPhone
                        ? `/55${clientWithPhone.phone}`
                        : "";
                      const textParam = clientWithPhone
                        ? text.replace("{fullname}", clientWithPhone.name)
                        : text.replace("%20{fullname}", "");
                      const url = `https://wa.me${phoneParam}?text=${textParam}`;
                      window.open(url, "_blank");
                    }}
                  >
                    <Row>
                      <BsWhatsapp
                        style={{
                          marginBottom: "20px",
                          width: "30px",
                          height: "30px",
                          color: "var(--yellow)",
                        }}
                      />
                    </Row>
                    Enviar lembrete por <strong>Whatsapp</strong>
                  </Card>
                </Col>
              </>
            )}
          </Row>
        </Modal>
        <Modal
          footer={null}
          title="Erro durante o processamento dos seguintes usuários."
          visible={errorModalVisible}
          onCancel={() => setErrorModalVisible(false)}
        >
          <Row gutter={[8, 8]}>
            <Table
              style={{ width: "100%" }}
              rowKey="cpf"
              loading={loadingGet}
              dataSource={errors}
              columns={[
                {
                  title: "Nome, CPF",
                  render: (_, item) => (
                    <>
                      <Row>
                        <Col span={24}>{item.user}</Col>
                      </Row>
                      <Row>
                        <Col span={24}>{maskCpf(item.cpf)}</Col>
                      </Row>
                    </>
                  ),
                },
                {
                  title: "Linha do excel",
                  align: "center",
                  render: (_, item) => (
                    <Row>
                      <Col span={24}>{item.position}</Col>
                    </Row>
                  ),
                },
                {
                  title: "Mensagem",
                  render: (_, item) => (
                    <Row>
                      <Col span={24}>{item.message}</Col>
                    </Row>
                  ),
                },
              ]}
            />
          </Row>
        </Modal>
        <Modal
          footer={null}
          title="Adicione seus clientes"
          visible={optionsModal}
          onCancel={() => setOptionsModal(false)}
        >
          <Row gutter={[16, 16]} style={{ marginBottom: "24px" }}>
            <Col>
              <Typography.Paragraph
                style={{ marginBottom: 0, fontWeight: "300" }}
              >
                Escolha a forma que deseja adicionar o cliente:
              </Typography.Paragraph>
            </Col>
            <Col span={isMobile() ? 24 : 12}>
              <Card className="add-card" onClick={setCreateModalVisibility}>
                <IoMdAddCircleOutline size={30} className="icon-card" />
                <Row className="modal-row">
                  <p>
                    Adicionar clientes <b>manualmente</b>
                  </p>
                </Row>
              </Card>
            </Col>
            <Col span={isMobile() ? 24 : 12}>
              <Card className="add-card" onClick={setCsvModalVisibility}>
                <AiOutlineUpload size={30} className="icon-card" />
                <Row className="modal-row">
                  <p>
                    Importar clientes de <b>planilha Excel</b>
                  </p>
                </Row>
              </Card>
            </Col>
          </Row>
        </Modal>
        <Modal
          footer={null}
          title="Carregue sua planilha"
          visible={csvModalVisible}
          onCancel={() => setCsvModalVisible(false)}
        >
          <Row gutter={[16, 16]}>
            <HiOutlineDownload
              size={20}
              className="icon-card"
              style={{ margin: "4px 5px" }}
            />
            <p
              style={{
                cursor: "pointer",
                margin: "4px 0px",
                fontWeight: "700",
              }}
              onClick={() => {
                window.open(
                  isManagerOrOffice
                    ? `https://velotax-assets.s3.amazonaws.com/cadastro_cliente_1_xp${env}.xlsx`
                    : `https://velotax-assets.s3.amazonaws.com/cadastro_cliente_2_xp${env}.xlsx`
                );
              }}
            >
              Baixar planilha modelo
            </p>
            <Col span={24}>
              <UploadVelotax
                accept="all"
                loading={loadingFile}
                beforeUpload={beforeUpload}
                customRequest={customRequest}
              />
            </Col>
          </Row>
        </Modal>
        <IntegrationModal
          integrationClient={integrationClient}
          integrationModal={integrationModal}
          setIntegrationModal={setIntegrationModal}
          sendMail={sendMail}
        />
        <Modal
          title="Recuperar informações"
          visible={createClientDeleted?.showModal}
          onCancel={() => setCreateClientDeleted({ showModal: false })}
          onOk={() => {
            restoreClient(
              (createClientDeleted.cpf || "").replace(/[_.-/-]/g, "")
            );
            setCreateClientDeleted({ showModal: false });
          }}
          okText="Recuperar"
          cancelText="Cancelar"
        >
          O Cliente <strong>{createClientDeleted?.name}</strong> (CPF:{" "}
          {createClientDeleted?.cpf}) foi excluído pelo escritório
          anteriormente. Gostaria de recuperar suas informações?
        </Modal>
        <Modal
          footer={null}
          title={`Tem certeza que deseja excluir ${itemRemove.name} da sua lista de clientes?`}
          visible={removeModalVisible}
          onCancel={handleRemoveModal}
        >
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <Button
                block
                size="large"
                type="ghost"
                onClick={handleRemoveModal}
              >
                Não
              </Button>
            </Col>
            <Col span={12}>
              <Button block size="large" type="primary" onClick={handleRemove}>
                Sim
              </Button>
            </Col>
          </Row>
        </Modal>

        <Modal
          width={700}
          open={patrimonioModalVisible}
          title="Atualizar patrimônios"
          onCancel={handlePatrimonioModal}
          footer={
            <Button
              block
              size="large"
              type="primary"
              onClick={() => handleUpdatePatrimonio(selectedClient)}
            >
              Atualizar patrimônios
            </Button>
          }
        >
          <Row>
            <Col>
              Deseja atualizar os valores de patrimônio de todos os seus
              clientes? Esse processo pode levar até{" "}
              {Math.min(30, totalClients * 2)} minutos. Quando for concluído
              enviaremos um e-mail confirmando.
            </Col>
          </Row>
        </Modal>
        <Modal
          footer={null}
          title="Lista completa de assessores"
          visible={assessoresListModal}
          onCancel={() => {
            setAssessoresListModal(false);
            setUserSelected({});
          }}
        >
          <Row style={{ marginBottom: "20px" }}>
            <Select
              mode="multiple"
              allowClear
              size="large"
              style={{ width: "100%", height: "auto" }}
              placeholder="Selecione os assessores desejados"
              loading={loadingGet}
              disabled={loadingGet}
              value={assessoresSelected}
              onChange={handleChangeAssessores}
            >
              {professionals.map((professional) => (
                <Select.Option
                  value={professional._id}
                  label={professional.name}
                >
                  <div className="demo-option-label-item">
                    {professional.name}
                  </div>
                </Select.Option>
              ))}
            </Select>
          </Row>
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <Button
                block
                size="large"
                type="ghost"
                onClick={() => {
                  setAssessoresListModal(false);
                  setUserSelected({});
                }}
              >
                Cancelar
              </Button>
            </Col>
            <Col span={12}>
              <Button
                block
                size="large"
                type="primary"
                onClick={() => {
                  updateClient(
                    {
                      ...userSelected,
                      assessores: assessoresSelected,
                      tableEdit: true,
                    },
                    currentPage
                  );
                  setAssessoresListModal(false);
                  setUserSelected({});
                }}
              >
                Atualizar
              </Button>
            </Col>
          </Row>
        </Modal>
      </Content>
      <Modal
        footer={null}
        open={showFilterModal}
        title="Filtrar clientes"
        className="filter-modal"
        onCancel={() => {
          setFilters(appliedFilters);
          setShowFilterModal(false);
        }}
      >
        <Row gutter={[24, 24]}>
          <Col span={24}>
            <Row gutter={[8, 8]}>
              <Col span={24}>
                <Typography.Text strong>Plano</Typography.Text>
              </Col>
              <Col span={24}>
                <Checkbox.Group
                  value={filters.planActive}
                  onChange={(planActive) => {
                    setFilters((filters: any) => ({ ...filters, planActive }));
                  }}
                >
                  <Row gutter={[4, 4]}>
                    <Col span={24}>
                      <Checkbox value="Gratuito">Gratuito</Checkbox>
                    </Col>
                    <Col span={24}>
                      <Checkbox value="Plano Basic">
                        Plano Basic
                      </Checkbox>
                    </Col>
                    <Col span={24}>
                      <Checkbox value="Plano Premium">
                        Plano Premium
                      </Checkbox>
                    </Col>
                    <Col span={24}>
                      <Checkbox value="Plano Concierge">
                        Plano Concierge
                      </Checkbox>
                    </Col>
                  </Row>
                </Checkbox.Group>
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <Row gutter={[8, 8]}>
              <Col span={24}>
                <Typography.Text strong>Responsável</Typography.Text>
              </Col>
              <Col span={24}>
                <Select
                  allowClear
                  size="large"
                  mode="multiple"
                  value={filters.resp}
                  placeholder="Selecionar"
                  style={{ minWidth: "50%", maxWidth: "100%" }}
                  getPopupContainer={(trigger) => trigger.parentNode}
                  onChange={(resp) => {
                    setFilters((filters: any) => ({ ...filters, resp }));
                  }}
                  options={[
                    { value: "Escritório", label: "Escritório" },
                    ...professionals.map((item) => ({
                      value: item._id,
                      label: item.name,
                    })),
                  ]}
                />
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <Row gutter={[8, 8]}>
              <Col span={24}>
                <Typography.Text strong>Bolsa de valores</Typography.Text>
              </Col>
              <Col span={24}>
                <Checkbox.Group
                  value={filters.statusBolsa}
                  onChange={(statusBolsa) => {
                    setFilters((filters: any) => ({ ...filters, statusBolsa }));
                  }}
                >
                  <Row gutter={[4, 4]}>
                    <Col span={24}>
                      <Checkbox value="Integração ativa">
                        Integração ativa
                      </Checkbox>
                    </Col>
                    <Col span={24}>
                      <Checkbox value="Integração inativa">
                        Integração inativa
                      </Checkbox>
                    </Col>
                  </Row>
                </Checkbox.Group>
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <Row gutter={[8, 8]}>
              <Col span={24}>
                <Typography.Text strong>Exterior</Typography.Text>
              </Col>
              <Col span={24}>
                <Checkbox.Group
                  value={filters.statusExterior}
                  onChange={(statusExterior) => {
                    setFilters((filters: any) => ({
                      ...filters,
                      statusExterior,
                    }));
                  }}
                >
                  <Row gutter={[4, 4]}>
                    <Col span={24}>
                      <Checkbox value="Integração ativa">
                        Integração ativa
                      </Checkbox>
                    </Col>
                    <Col span={24}>
                      <Checkbox value="Integração inativa">
                        Integração inativa
                      </Checkbox>
                    </Col>
                  </Row>
                </Checkbox.Group>
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <Button
              block
              size="large"
              type="primary"
              loading={loadingGet}
              onClick={() => {
                setAppliedFilters(filters);
                getClients({
                  searchText,
                  page: pagination.current,
                  pageSize: pagination.pageSize,
                  planActive: (filters.planActive || []) as string[],
                  resp: (filters.resp || []) as string[],
                  statusBolsa: filters.statusBolsa as CalcStatus[],
                  statusExterior: filters.statusExterior as CalcStatus[],
                });
                setTimeout(() => {
                  setShowFilterModal(false);
                }, 500);
              }}
            >
              Aplicar
            </Button>
          </Col>
        </Row>
      </Modal>
      <Modal
        footer={
          <Button
            block
            size="large"
            type="primary"
            icon={<BiCheck />}
            onClick={() => {
              setShowCorretoraFilterModal(false);
              setSelectedCorretoras(checkboxCorretoras);

              const corretorasFiltradas = checkboxCorretoras.map((corretora: string) =>
                getNomeCorretora({ shortName: corretora })
              );

              setFilterCorretoraAtivo(corretorasFiltradas);

              updateFilter();
            }}
          >
            Confirmar
          </Button>
        }
        open={showCorretoraFilterModal}
        title="Filtrar por corretora"
        className="filter-modal"
        onCancel={() => {
          setShowCorretoraFilterModal(false);
        }}
      >
        <Row gutter={[24, 24]}>
          <Col span={24}>
            <Row gutter={[8, 8]}>
              <Col span={24}>
                <Typography.Text strong>Corretoras</Typography.Text>
              </Col>
              <Col span={24}>
                <Checkbox
                  checked={checkAll}
                  indeterminate={indeterminate}
                  className="corretoras-allcheck"
                  onChange={(e: any) => {
                    setCheckboxCorretoras(e.target.checked ? corretoras : []);
                  }}
                >
                  Todas as corretoras
                </Checkbox>
                <Checkbox.Group
                  value={checkboxCorretoras}
                  onChange={(e: any) => {
                    setCheckboxCorretoras(e);
                  }}
                >
                  <Row gutter={[4, 4]}>
                    {corretoras.map((corretora, i) => (
                      <Col span={24} key={i}>
                        <Checkbox value={corretora}>{corretora}</Checkbox>
                      </Col>
                    ))}
                  </Row>
                </Checkbox.Group>
              </Col>
            </Row>
          </Col>
        </Row>
        <div className="ant-modal-header" style={{ padding: '8px 0', margin: '2rem 0' }}>
          <div className="ant-modal-title">
            Filtrar por posições
          </div>
        </div>
        <Select
          mode="multiple"
          allowClear
          style={{ width: '100%', margin: '1rem 0' }}
          placeholder="Filtrar posições"
          value={posicoesFilter || []}
          onChange={(e: any) => {
            setCheckboxCorretoras([])
            setPosicoesFilter(e || [])
          }}
          options={Object.keys(carteiraCategorizadaSemFiltros).map((categoria) => ({
            label: categoria,
            options: carteiraCategorizadaSemFiltros[categoria].map((c: any) => ({
              label: c.codigo,
              value: c.codigo,
            }))
          }))}
        />
      </Modal>
      <OperationModal
        modalOperationsOpen={modalOperationsOpen}
        setModalOperationsOpen={setModalOperationsOpen}
        clientsSelected={darfSelected || []}
        handleDarfDownload={handleDarfDownload}
        handleDarfSend={handleDarfSendAction}
        loadingDownload={loading}
      />
      <SendDarfModal
        showSendDarfModal={showSendDarfModal}
        setShowSendDarfModal={setShowSendDarfModal}
        clientsSelected={darfSelected}
        setClientsSelected={setDarfSelected}
        sendToResp={sendToResp}
        setSendToResp={setSendToResp}
        whatsappRedirectURL={whatsappRedirectURL}
        setWhatsappRedirectURL={setWhatsappRedirectURL}
      />
      <NotificationDrawer
        filters={filters}
        searchText={searchText}
        currentPage={currentPage}
        open={notificationDrawerOpen}
        onClose={() => setNotificationDrawerOpen(false)}
      />
      <ProventosModal
        open={openModal}
        setOpenModal={setOpenModal}
        month={monthProventos.name}
        yearProventos={yearProventos}
        downloadExcel={downloadExcel}
        selectedClient={selectedClient}
        setYearProventos={setYearProventos}
        proventosLoading={proventosLoading}
        setMonthProventos={setMonthProventos}
      />
    </Container>
  );
};
